export const uiExamples = [
  
  {
    uiName: "Textual_format_list",
    artifact_id: "e1f2g3h4-i5j6-7890-1234-567890abcdef",
    title: "3-Day Thailand Itinerary",
    contentType: "application/json",
    prompt:`Convert the following text into a clear, structured format. Follow these rules:

1. Add a concise and appropriate heading at the top.
2. Break the content into bullet points using a dot (•) for each point.
3. Bold only the important or key parts within each bullet point.

Keep the tone simple and professional.`,
    data: {
      time: 1749903900000,
      blocks: [
        // testing
{
    "id": "block-b59444cb-5cbe-4162-95d4-e06e784061b5",
    "type": "section",
    "isMerged": true,
    "display_name": "Merged Section",
    "children": [
        {
            "id": "block-day-1-header",
            "type": "header",
            "display_name": "Day 1",
            "data": {
                "elements": [
                    {
                        "field": "text",
                        "value": "Textual format1"
                    },
                    {
                        "field": "display_name",
                        "value": "Textual format1"
                    }
                ]
            },
            "css": {
                "header": {
                    "fontSize": "14px",
                    "fontWeight": "600",
                    "color": "#1e40af",
                    "backgroundColor": "#dbeafe",
                    "padding": "4px 8px",
                    "borderRadius": "4px",
                    "fontFamily": "'Arial', sans-serif"
                }
            },
            "outerCss": {
                "display": "flex",
                "flexDirection": "column",
                "backgroundColor": "transparent",
                "padding": "0px"
            },
            "default_fields": {},
            "is_default_value": false,
            "add_display_name": false,
            "path": null
        },
       
    ],
    "is_default_value": false,
    "add_display_name": false
},
        // testing
        // Day 1
       {
          id: "block-90123456-7890-abcd-ef12-34567890abcd",
          type: "list",
          display_name: "Key Conference Sessions",
          data: {
            elements: [
              {
                field: "items",
                value: [
                  "Keynote: Future of AI",
                  "Panel: Sustainable Business Practices",
                  "Workshop: Leadership Strategies",
                  "Networking Dinner",
                ],
              },
              {
                field: "display_name",
                value: "Key Conference Sessions",
              },
            ],
          },
          css: {
            list: {
              fontSize: "16px",
              margin: "12px 0",
              paddingLeft: "20px",
              color: "black",
              fontFamily: "'Verdana', Arial, sans-serif",
              transition: "all 0.3s ease",
            },
            displayName: {
              fontSize: "16px",
              fontWeight: "600",
              color: "#1a3c34",
              marginBottom: "8px",
              fontFamily: "'Verdana', Arial, sans-serif",
              transition: "all 0.3s ease",
            },
            displayNameContainer: {
              padding: "8px",
              backgroundColor: "#e6edeb",
              borderRadius: "4px",

              marginBottom: "8px",
              transition: "all 0.3s ease",
            },
          },
          outerCss: {
            backgroundColor: "#f7f9f8",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "left",
          },
          default_fields: {},
          is_default_value: false,
          add_display_name: false,
        },
       
      ],
    },
  }
  ,
//   {
//     uiName: "Textual_format",
//     artifact_id: "e1f2g3h4-i5j6-7890-1234-567890abcdef",
//     title: "3-Day Thailand Itinerary",
//     contentType: "application/json",
//     prompt:"Make the important or key parts of the following text bold. Do not rewrite the entire sentence—only bold the most important words or phrases. Keep the original structure and wording of the text the same.",
//     data: {
//       time: 1749903900000,
//       blocks: [
//         // testing
// {
//     "id": "block-b59444cb-5cbe-4162-95d4-e06e784061b5",
//     "type": "section",
//     "isMerged": true,
//     "display_name": "Merged Section",
//     "children": [
//         {
//             "id": "block-day-1-header",
//             "type": "header",
//             "display_name": "Day 1",
//             "data": {
//                 "elements": [
//                     {
//                         "field": "text",
//                         "value": "Textual format2"
//                     },
//                     {
//                         "field": "display_name",
//                         "value": "Textual format2"
//                     }
//                 ]
//             },
//             "css": {
//                 "header": {
//                     "fontSize": "14px",
//                     "fontWeight": "600",
//                     "color": "#1e40af",
//                     "backgroundColor": "#dbeafe",
//                     "padding": "4px 8px",
//                     "borderRadius": "4px",
//                     "fontFamily": "'Arial', sans-serif"
//                 }
//             },
//             "outerCss": {
//                 "display": "flex",
//                 "flexDirection": "column",
//                 "backgroundColor": "transparent",
//                 "padding": "0px"
//             },
//             "default_fields": {},
//             "is_default_value": false,
//             "add_display_name": false,
//             "path": null
//         },
       
//     ],
//     "is_default_value": false,
//     "add_display_name": false
// },
//         // testing
//         // Day 1
//       {
//         "id": "block-margherita-description",
//         "type": "paragraph",
//         "display_name": "Description",
//         "data": {
//           "elements": [
//             {
//               "field": "text",
//               "value": "A classic pizza with fresh mozzarella, tomatoes, and basil."
//             },
//             {
//               "field": "display_name",
//               "value": "Description"
//             }
//           ]
//         },
//         "css": {
//           "paragraph": {
//             "color": "black",
//             "fontSize": "14px",
        
//           },
//           "displayName": {
//             "fontSize": "14px",
//             "fontWeight": "500",
//             "color": "#4a4a4a",
//             "margin": "0",
//             "fontFamily": "'Inter', sans-serif",
//             "textAlign": "left"
//           },
//           "displayNameContainer": {
//             "padding": "0",
//             "backgroundColor": "transparent",
//             "margin": "0",
//             "textAlign": "left"
//           }
//         },
//         "outerCss": {
//           "backgroundColor": "#ffffff",
//           "justifyContent": "flex-start",
//           "alignItems": "flex-start",
//           "textAlign": "left",
//           "padding": "8px",
//           "boxSizing": "border-box",
//           "display": "flex",
//           "flexDirection": "column",
//           "gap": "4px"
//         },
//         "default_fields": {},
//         "is_default_value": false,
//         "add_display_name": false
//       },
       
//       ],
//     },
//   }
//   ,



  {
    uiName: "Itinerary",
    artifact_id: "e1f2g3h4-i5j6-7890-1234-567890abcdef",
    title: "3-Day Thailand Itinerary",
    contentType: "application/json",
    data: {
      time: 1749903900000,
      blocks: [
        // testing
{
    "id": "block-b59444cb-5cbe-4162-95d4-e06e784061b5",
    "type": "section",
    "isMerged": true,
    "display_name": "Merged Section",
    "children": [
        {
            "id": "block-day-1-header",
            "type": "header",
            "display_name": "Day 1",
            "data": {
                "elements": [
                    {
                        "field": "text",
                        "value": "Day 1"
                    },
                    {
                        "field": "display_name",
                        "value": "Day 1"
                    }
                ]
            },
            "css": {
                "header": {
                    "fontSize": "14px",
                    "fontWeight": "600",
                    "color": "#1e40af",
                    "backgroundColor": "#dbeafe",
                    "padding": "4px 8px",
                    "borderRadius": "4px",
                    "fontFamily": "'Arial', sans-serif"
                }
            },
            "outerCss": {
                "display": "flex",
                "flexDirection": "column",
                "backgroundColor": "transparent",
                "padding": "0px"
            },
            "default_fields": {},
            "is_default_value": false,
            "add_display_name": false,
            "path": null
        },
        {
            "id": "block-day-1-image",
            "type": "image",
            "display_name": "Phuket Image",
            "data": {
                "elements": [
                    {
                        "field": "files",
                        "value": [
                            {
                                "url": "https://cdn.pixabay.com/photo/2017/09/16/18/47/phuket-2756386_1280.jpg"
                            }
                        ]
                    },
                    {
                        "field": "display_name",
                        "value": "Phuket Image"
                    }
                ]
            },
            "css": {
                "image": {
                    "width": "96px",
                    "height": "96px",
                    "objectFit": "cover",
                    "borderRadius": "4px"
                }
            },
            "outerCss": {
                "display": "flex",
                "flexDirection": "column",
                "backgroundColor": "transparent",
                "padding": "0px"
            },
            "default_fields": {},
            "is_default_value": false,
            "add_display_name": false,
            "path": null
        }
    ],
    "is_default_value": false,
    "add_display_name": false
},
        // testing
        // Day 1
        {
          id: "block-day-1-header",
          type: "header",
          display_name: "Day 1",
          data: {
            elements: [
              { field: "text", value: "Day 1" },
              { field: "display_name", value: "Day 1" },
            ],
          },
          css: {
            header: {
              fontSize: "14px",
              fontWeight: "600",
              color: "#1e40af",
              backgroundColor: "#dbeafe",
              padding: "4px 8px",
              borderRadius: "4px",
              fontFamily: "'Arial', sans-serif",
            },
          },
          outerCss: {
            display: "flex",
            flexDirection: "column",
            backgroundColor: "transparent",
            padding: "0px",
          },
          add_display_name: false,
        },
        {
          id: "block-day-1-image",
          type: "image",
          display_name: "Phuket Image",
          data: {
            elements: [
              {
                field: "files",
                value: [
                  {
                    url: "https://cdn.pixabay.com/photo/2017/09/16/18/47/phuket-2756386_1280.jpg",
                  },
                ],
              },
              { field: "display_name", value: "Phuket Image" },
            ],
          },
          css: {
            image: {
              width: "96px",
              height: "96px",
              objectFit: "cover",
              borderRadius: "4px",
            },
          },
          outerCss: {
            display: "flex",
            flexDirection: "column",
            backgroundColor: "transparent",
            padding: "0px",
          },
          add_display_name: false,
        },
        {
          id: "block-day-1-activity-1",
          type: "paragraph",
          display_name: "Activity 1",
          data: {
            elements: [
              {
                field: "text",
                value: "Arrive in Phuket and check into your hotel.",
              },
              { field: "display_name", value: "Activity 1" },
            ],
          },
          css: {
            paragraph: {
              fontSize: "14px",
              color: "#333333",
              fontFamily: "'Arial', sans-serif",
            },
          },
          outerCss: {
            display: "flex",
            flexDirection: "column",
            backgroundColor: "transparent",
            padding: "0px",
          },
          add_display_name: false,
        },
        {
          id: "block-day-1-activity-2",
          type: "paragraph",
          display_name: "Activity 3",
          data: {
            elements: [
              {
                field: "text",
                value:
                  "Spend the afternoon exploring the city, visiting places such as the Grand Palace, the Wat Pho temple and the Temple ...",
              },
              { field: "display_name", value: "Activity 2" },
            ],
          },
          css: {
            paragraph: {
              fontSize: "14px",
              color: "#333333",
              fontFamily: "'Arial', sans-serif",
            },
          },
          outerCss: {
            display: "flex",
            flexDirection: "column",
            backgroundColor: "transparent",
            padding: "0px",
          },
          add_display_name: false,
        },
        {
          id: "block-day-1-activity-3",
          type: "paragraph",
          display_name: "Activity 4",
          data: {
            elements: [
              {
                field: "text",
                value:
                  "Spend the afternoon exploring the city, visiting places such as the Grand Palace, the Wat Pho temple and the Temple ...",
              },
              { field: "display_name", value: "Activity 2" },
            ],
          },
          css: {
            paragraph: {
              fontSize: "14px",
              color: "#333333",
              fontFamily: "'Arial', sans-serif",
            },
          },
          outerCss: {
            display: "flex",
            flexDirection: "column",
            backgroundColor: "transparent",
            padding: "0px",
          },
          add_display_name: false,
        },
        {
          id: "block-day-1-activity-4",
          type: "paragraph",
          display_name: "Activity 5",
          data: {
            elements: [
              {
                field: "text",
                value:
                  "Spend the afternoon exploring the city, visiting places such as the Grand Palace, the Wat Pho temple and the Temple ...",
              },
              { field: "display_name", value: "Activity 2" },
            ],
          },
          css: {
            paragraph: {
              fontSize: "14px",
              color: "#333333",
              fontFamily: "'Arial', sans-serif",
            },
          },
          outerCss: {
            display: "flex",
            flexDirection: "column",
            backgroundColor: "transparent",
            padding: "0px",
          },
          add_display_name: false,
        },
       
      ],
    },
  }
  ,
{
  "uiName": "Checkout Card",
  "title": "Checkout Card",
  "contentType": "application/json",
  "data": {
    "time": 1749903900000,
    "blocks": [
      {
        "id": "block-checkout-header",
        "type": "header",
        "display_name": "Checkout",
        "data": {
          "elements": [
            {
              "field": "text",
              "value": "Checkout"
            },
            {
              "field": "display_name",
              "value": "Checkout"
            }
          ]
        },
        "css": {
          "header": {
            "color": "#1a1a1a",
            "fontWeight": "700",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif",
            "fontSize": "24px",
            "boxSizing": "border-box",
            "textAlign": "left"
          },
          "displayName": {
            "fontSize": "20px",
            "fontWeight": "600",
            "color": "#1a1a1a",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif",
            "textAlign": "left"
          },
          "displayNameContainer": {
            "padding": "0",
            "backgroundColor": "transparent",
            "margin": "0",
            "textAlign": "left"
          }
        },
        "outerCss": {
          "backgroundColor": "#ffffff",
          "justifyContent": "flex-start",
          "alignItems": "flex-start",
          "padding": "8px",
          "textAlign": "left",
          "boxSizing": "border-box",
          "display": "flex",
          "flexDirection": "column",
          "gap": "4px",
          "borderBottom": "2px solid #e0e0e0"
        },
        "default_fields": {},
        "is_default_value": false,
        "add_display_name": false
      },
      {
        "id": "block-margherita-title",
        "type": "header",
        "display_name": "Margherita - Small",
        "data": {
          "elements": [
            {
              "field": "text",
              "value": "Margherita - Small"
            },
            {
              "field": "display_name",
              "value": "name"
            }
          ]
        },
        "css": {
          "header": {
            "color": "#1a1a1a",
            "fontWeight": "600",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif",
            "fontSize": "18px",
            "boxSizing": "border-box",
            "textAlign": "left"
          },
          "displayName": {
            "fontSize": "16px",
            "fontWeight": "600",
            "color": "#1a1a1a",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif",
            "textAlign": "left"
          },
          "displayNameContainer": {
            "padding": "0",
            "backgroundColor": "transparent",
            "margin": "0",
            "textAlign": "left"
          }
        },
        "outerCss": {
          "backgroundColor": "#ffffff",
          "justifyContent": "flex-start",
          "alignItems": "flex-start",
          "padding": "8px",
          "textAlign": "left",
          "boxSizing": "border-box",
          "display": "flex",
          "flexDirection": "column",
          "gap": "4px"
        },
        "default_fields": {},
        "is_default_value": false,
        "add_display_name": false
      },
      {
        "id": "block-margherita-image",
        "type": "image",
        "display_name": "Image",
        "data": {
          "elements": [
            {
              "field": "files",
              "value": [
                {
                  "url": "https://media.istockphoto.com/id/184946701/photo/pizza.jpg?s=612x612&w=0&k=20&c=97rc0VIi-s3mn4xe4xDy9S-XJ_Ohbn92XaEMaiID_eY="
                }
              ]
            },
            {
              "field": "display_name",
              "value": "Image"
            }
          ]
        },
        "css": {
          "image": {
            "width": "100%",
            // "height": "100px",
            "objectFit": "cover",
            "borderRadius": "8px",
            "margin": "0 0px 0 0",
            "boxSizing": "border-box"
          },
          "displayName": {
            "fontSize": "14px",
            "fontWeight": "500",
            "color": "#1a1a1a",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif"
          },
          "displayNameContainer": {
            "padding": "0",
            "backgroundColor": "transparent",
            "margin": "0"
          }
        },
        "outerCss": {
          "backgroundColor": "#ffffff",
          "justifyContent": "flex-start",
          "alignItems": "center",
          "textAlign": "left",
          "padding": "8px",
          "boxSizing": "border-box",
          "display": "flex",
          "flexDirection": "row",
          "gap": "8px",
          "borderBottom": "1px solid #e0e0e0"
        },
        "default_fields": {},
        "is_default_value": false,
        "add_display_name": false
      },
      {
        "id": "block-margherita-description",
        "type": "paragraph",
        "display_name": "Description",
        "data": {
          "elements": [
            {
              "field": "text",
              "value": "A classic pizza with fresh mozzarella, tomatoes, and basil."
            },
            {
              "field": "display_name",
              "value": "Description"
            }
          ]
        },
        "css": {
          "paragraph": {
            "color": "#4a4a4a",
            "fontSize": "14px",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif",
            "boxSizing": "border-box",
            "textAlign": "left",
            "lineHeight": "1.4"
          },
          "displayName": {
            "fontSize": "14px",
            "fontWeight": "500",
            "color": "#4a4a4a",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif",
            "textAlign": "left"
          },
          "displayNameContainer": {
            "padding": "0",
            "backgroundColor": "transparent",
            "margin": "0",
            "textAlign": "left"
          }
        },
        "outerCss": {
          "backgroundColor": "#ffffff",
          "justifyContent": "flex-start",
          "alignItems": "flex-start",
          "textAlign": "left",
          "padding": "8px",
          "boxSizing": "border-box",
          "display": "flex",
          "flexDirection": "column",
          "gap": "4px"
        },
        "default_fields": {},
        "is_default_value": false,
        "add_display_name": false
      },
      {
        "id": "block-margherita-quantity",
        "type": "paragraph",
        "display_name": "Quantity",
        "data": {
          "elements": [
            {
              "field": "text",
              "value": "1"
            },
            {
              "field": "display_name",
              "value": "Quantity"
            }
          ]
        },
        "css": {
          "paragraph": {
            "fontSize": "14px",
            "fontWeight": "500",
            "color": "#1976d2",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif",
            "boxSizing": "border-box",
            "textAlign": "left"
          },
          "displayName": {
            "fontSize": "14px",
            "fontWeight": "500",
            "color": "#1976d2",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif",
            "textAlign": "left"
          },
          "displayNameContainer": {
            "padding": "0",
            "backgroundColor": "transparent",
            "margin": "0",
            "textAlign": "left"
          }
        },
        "outerCss": {
          "backgroundColor": "#ffffff",
          "justifyContent": "space-between",
          "alignItems": "center",
          "textAlign": "left",
          "padding": "4px 8px",
          "boxSizing": "border-box",
          "display": "flex",
          "flexDirection": "row",
          "gap": "4px"
        },
        "default_fields": {},
        "is_default_value": false,
        "add_display_name": true
      },
      {
        "id": "block-margherita-base-price",
        "type": "paragraph",
        "display_name": "Base Price",
        "data": {
          "elements": [
            {
              "field": "text",
              "value": "$8.00"
            },
            {
              "field": "display_name",
              "value": "Base Price"
            }
          ]
        },
        "css": {
          "paragraph": {
            "fontSize": "14px",
            "fontWeight": "500",
            "color": "#2e7d32",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif",
            "boxSizing": "border-box",
            "textAlign": "left"
          },
          "displayName": {
            "fontSize": "14px",
            "fontWeight": "500",
            "color": "#2e7d32",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif",
            "textAlign": "left"
          },
          "displayNameContainer": {
            "padding": "0",
            "backgroundColor": "transparent",
            "margin": "0",
            "textAlign": "left"
          }
        },
        "outerCss": {
          "backgroundColor": "#ffffff",
          "justifyContent": "space-between",
          "alignItems": "center",
          "textAlign": "left",
          "padding": "4px 8px",
          "boxSizing": "border-box",
          "display": "flex",
          "flexDirection": "row",
          "gap": "4px"
        },
        "default_fields": {},
        "is_default_value": false,
        "add_display_name": true
      },
      {
        "id": "block-margherita-topping-price",
        "type": "paragraph",
        "display_name": "Topping Price",
        "data": {
          "elements": [
            {
              "field": "text",
              "value": "$2.50"
            },
            {
              "field": "display_name",
              "value": "Topping Price"
            }
          ]
        },
        "css": {
          "paragraph": {
            "fontSize": "14px",
            "fontWeight": "500",
            "color": "#d81b60",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif",
            "boxSizing": "border-box",
            "textAlign": "left"
          },
          "displayName": {
            "fontSize": "14px",
            "fontWeight": "500",
            "color": "#d81b60",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif",
            "textAlign": "left"
          },
          "displayNameContainer": {
            "padding": "0",
            "backgroundColor": "transparent",
            "margin": "0",
            "textAlign": "left"
          }
        },
        "outerCss": {
          "backgroundColor": "#ffffff",
          "justifyContent": "space-between",
          "alignItems": "center",
          "textAlign": "left",
          "padding": "4px 8px",
          "boxSizing": "border-box",
          "display": "flex",
          "flexDirection": "row",
          "gap": "4px"
        },
        "default_fields": {},
        "is_default_value": false,
        "add_display_name": true
      },
      {
        "id": "block-margherita-total-price",
        "type": "paragraph",
        "display_name": "Total Price",
        "data": {
          "elements": [
            {
              "field": "text",
              "value": "$10.50"
            },
            {
              "field": "display_name",
              "value": "Total Price"
            }
          ]
        },
        "css": {
          "paragraph": {
            "fontSize": "15px",
            "fontWeight": "600",
            "color": "#1a1a1a",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif",
            "boxSizing": "border-box",
            "textAlign": "left"
          },
          "displayName": {
            "fontSize": "15px",
            "fontWeight": "600",
            "color": "#1a1a1a",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif",
            "textAlign": "left"
          },
          "displayNameContainer": {
            "padding": "0",
            "backgroundColor": "transparent",
            "margin": "0",
            "textAlign": "left"
          }
        },
        "outerCss": {
          "backgroundColor": "#f5f5f5",
          "justifyContent": "space-between",
          "alignItems": "center",
          "textAlign": "left",
          "padding": "8px",
          "boxSizing": "border-box",
          "display": "flex",
          "flexDirection": "row",
          "gap": "4px",
          "borderTop": "1px solid #e0e0e0",
          "borderBottom": "1px solid #e0e0e0"
        },
        "default_fields": {},
        "is_default_value": false,
        "add_display_name": true
      },
      {
        "id": "block-pepperoni-title",
        "type": "header",
        "display_name": "Pepperoni - Medium",
        "data": {
          "elements": [
            {
              "field": "text",
              "value": "Pepperoni - Medium"
            },
            {
              "field": "display_name",
              "value": "name"
            }
          ]
        },
        "css": {
          "header": {
            "color": "#1a1a1a",
            "fontWeight": "600",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif",
            "fontSize": "18px",
            "boxSizing": "border-box",
            "textAlign": "left"
          },
          "displayName": {
            "fontSize": "16px",
            "fontWeight": "600",
            "color": "#1a1a1a",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif",
            "textAlign": "left"
          },
          "displayNameContainer": {
            "padding": "0",
            "backgroundColor": "transparent",
            "margin": "0",
            "textAlign": "left"
          }
        },
        "outerCss": {
          "backgroundColor": "#ffffff",
          "justifyContent": "flex-start",
          "alignItems": "flex-start",
          "padding": "8px",
          "textAlign": "left",
          "boxSizing": "border-box",
          "display": "flex",
          "flexDirection": "column",
          "gap": "4px"
        },
        "default_fields": {},
        "is_default_value": false,
        "add_display_name": false
      },
      {
        "id": "block-pepperoni-image",
        "type": "image",
        "display_name": "Image",
        "data": {
          "elements": [
            {
              "field": "files",
              "value": [
                {
                  "url": "https://static.wixstatic.com/media/597497_39dfa709d3d845eeaf43eb692e93b31b~mv2.jpg/v1/fill/w_6240,h_4160,al_c,q_90/Pepperoni%20Pizza_1_compressed.jpg"
                }
              ]
            },
            {
              "field": "display_name",
              "value": "Image"
            }
          ]
        },
        "css": {
          "image": {
            "width": "100%",
            // "height": "100px",
            "objectFit": "cover",
            "borderRadius": "8px",
            "margin": "0 0px 0 0",
            "boxSizing": "border-box"
          },
          "displayName": {
            "fontSize": "14px",
            "fontWeight": "500",
            "color": "#1a1a1a",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif"
          },
          "displayNameContainer": {
            "padding": "0",
            "backgroundColor": "transparent",
            "margin": "0"
          }
        },
        "outerCss": {
          "backgroundColor": "#ffffff",
          "justifyContent": "flex-start",
          "alignItems": "center",
          "textAlign": "left",
          "padding": "8px",
          "boxSizing": "border-box",
          "display": "flex",
          "flexDirection": "row",
          "gap": "8px",
          "borderBottom": "1px solid #e0e0e0"
        },
        "default_fields": {},
        "is_default_value": false,
        "add_display_name": false
      },
      {
        "id": "block-pepperoni-description",
        "type": "paragraph",
        "display_name": "Description",
        "data": {
          "elements": [
            {
              "field": "text",
              "value": "A savory pizza with pepperoni, mozzarella, and tomato sauce."
            },
            {
              "field": "display_name",
              "value": "Description"
            }
          ]
        },
        "css": {
          "paragraph": {
            "color": "#4a4a4a",
            "fontSize": "14px",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif",
            "boxSizing": "border-box",
            "textAlign": "left",
            "lineHeight": "1.4"
          },
          "displayName": {
            "fontSize": "14px",
            "fontWeight": "500",
            "color": "#4a4a4a",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif",
            "textAlign": "left"
          },
          "displayNameContainer": {
            "padding": "0",
            "backgroundColor": "transparent",
            "margin": "0",
            "textAlign": "left"
          }
        },
        "outerCss": {
          "backgroundColor": "#ffffff",
          "justifyContent": "flex-start",
          "alignItems": "flex-start",
          "textAlign": "left",
          "padding": "8px",
          "boxSizing": "border-box",
          "display": "flex",
          "flexDirection": "column",
          "gap": "4px"
        },
        "default_fields": {},
        "is_default_value": false,
        "add_display_name": false
      },
      {
        "id": "block-pepperoni-quantity",
        "type": "paragraph",
        "display_name": "Quantity",
        "data": {
          "elements": [
            {
              "field": "text",
              "value": "2"
            },
            {
              "field": "display_name",
              "value": "Quantity"
            }
          ]
        },
        "css": {
          "paragraph": {
            "fontSize": "14px",
            "fontWeight": "500",
            "color": "#1976d2",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif",
            "boxSizing": "border-box",
            "textAlign": "left"
          },
          "displayName": {
            "fontSize": "14px",
            "fontWeight": "500",
            "color": "#1976d2",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif",
            "textAlign": "left"
          },
          "displayNameContainer": {
            "padding": "0",
            "backgroundColor": "transparent",
            "margin": "0",
            "textAlign": "left"
          }
        },
        "outerCss": {
          "backgroundColor": "#ffffff",
          "justifyContent": "space-between",
          "alignItems": "center",
          "textAlign": "left",
          "padding": "4px 8px",
          "boxSizing": "border-box",
          "display": "flex",
          "flexDirection": "row",
          "gap": "4px"
        },
        "default_fields": {},
        "is_default_value": false,
        "add_display_name": true
      },
      {
        "id": "block-pepperoni-base-price",
        "type": "paragraph",
        "display_name": "Base Price",
        "data": {
          "elements": [
            {
              "field": "text",
              "value": "$10.00"
            },
            {
              "field": "display_name",
              "value": "Base Price"
            }
          ]
        },
        "css": {
          "paragraph": {
            "fontSize": "14px",
            "fontWeight": "500",
            "color": "#2e7d32",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif",
            "boxSizing": "border-box",
            "textAlign": "left"
          },
          "displayName": {
            "fontSize": "14px",
            "fontWeight": "500",
            "color": "#2e7d32",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif",
            "textAlign": "left"
          },
          "displayNameContainer": {
            "padding": "0",
            "backgroundColor": "transparent",
            "margin": "0",
            "textAlign": "left"
          }
        },
        "outerCss": {
          "backgroundColor": "#ffffff",
          "justifyContent": "space-between",
          "alignItems": "center",
          "textAlign": "left",
          "padding": "4px 8px",
          "boxSizing": "border-box",
          "display": "flex",
          "flexDirection": "row",
          "gap": "4px"
        },
        "default_fields": {},
        "is_default_value": false,
        "add_display_name": true
      },
      {
        "id": "block-pepperoni-topping-price",
        "type": "paragraph",
        "display_name": "Topping Price",
        "data": {
          "elements": [
            {
              "field": "text",
              "value": "$3.00"
            },
            {
              "field": "display_name",
              "value": "Topping Price"
            }
          ]
        },
        "css": {
          "paragraph": {
            "fontSize": "14px",
            "fontWeight": "500",
            "color": "#d81b60",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif",
            "boxSizing": "border-box",
            "textAlign": "left"
          },
          "displayName": {
            "fontSize": "14px",
            "fontWeight": "500",
            "color": "#d81b60",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif",
            "textAlign": "left"
          },
          "displayNameContainer": {
            "padding": "0",
            "backgroundColor": "transparent",
            "margin": "0",
            "textAlign": "left"
          }
        },
        "outerCss": {
          "backgroundColor": "#ffffff",
          "justifyContent": "space-between",
          "alignItems": "center",
          "textAlign": "left",
          "padding": "4px 8px",
          "boxSizing": "border-box",
          "display": "flex",
          "flexDirection": "row",
          "gap": "4px"
        },
        "default_fields": {},
        "is_default_value": false,
        "add_display_name": true
      },
      {
        "id": "block-pepperoni-total-price",
        "type": "paragraph",
        "display_name": "Total Price",
        "data": {
          "elements": [
            {
              "field": "text",
              "value": "$26.00"
            },
            {
              "field": "display_name",
              "value": "Total Price"
            }
          ]
        },
        "css": {
          "paragraph": {
            "fontSize": "15px",
            "fontWeight": "600",
            "color": "#1a1a1a",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif",
            "boxSizing": "border-box",
            "textAlign": "left"
          },
          "displayName": {
            "fontSize": "15px",
            "fontWeight": "600",
            "color": "#1a1a1a",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif",
            "textAlign": "left"
          },
          "displayNameContainer": {
            "padding": "0",
            "backgroundColor": "transparent",
            "margin": "0",
            "textAlign": "left"
          }
        },
        "outerCss": {
          "backgroundColor": "#f5f5f5",
          "justifyContent": "space-between",
          "alignItems": "center",
          "textAlign": "left",
          "padding": "8px",
          "boxSizing": "border-box",
          "display": "flex",
          "flexDirection": "row",
          "gap": "4px",
          "borderTop": "1px solid #e0e0e0",
          "borderBottom": "1px solid #e0e0e0"
        },
        "default_fields": {},
        "is_default_value": false,
        "add_display_name": true
      },
      {
        "id": "block-total-base-price",
        "type": "paragraph",
        "display_name": "Total Base Price",
        "data": {
          "elements": [
            {
              "field": "text",
              "value": "$28.00"
            },
            {
              "field": "display_name",
              "value": "Total Base Price"
            }
          ]
        },
        "css": {
          "paragraph": {
            "fontSize": "14px",
            "fontWeight": "500",
            "color": "#2e7d32",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif",
            "boxSizing": "border-box",
            "textAlign": "left"
          },
          "displayName": {
            "fontSize": "14px",
            "fontWeight": "500",
            "color": "#2e7d32",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif",
            "textAlign": "left"
          },
          "displayNameContainer": {
            "padding": "0",
            "backgroundColor": "transparent",
            "margin": "0",
            "textAlign": "left"
          }
        },
        "outerCss": {
          "backgroundColor": "#ffffff",
          "justifyContent": "space-between",
          "alignItems": "center",
          "textAlign": "left",
          "padding": "4px 8px",
          "boxSizing": "border-box",
          "display": "flex",
          "flexDirection": "row",
          "gap": "4px",
          "borderTop": "1px solid #e0e0e0"
        },
        "default_fields": {},
        "is_default_value": false,
        "add_display_name": true
      },
      {
        "id": "block-total-topping-price",
        "type": "paragraph",
        "display_name": "Total Topping Price",
        "data": {
          "elements": [
            {
              "field": "text",
              "value": "$8.50"
            },
            {
              "field": "display_name",
              "value": "Total Topping Price"
            }
          ]
        },
        "css": {
          "paragraph": {
            "fontSize": "14px",
            "fontWeight": "500",
            "color": "#d81b60",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif",
            "boxSizing": "border-box",
            "textAlign": "left"
          },
          "displayName": {
            "fontSize": "14px",
            "fontWeight": "500",
            "color": "#d81b60",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif",
            "textAlign": "left"
          },
          "displayNameContainer": {
            "padding": "0",
            "backgroundColor": "transparent",
            "margin": "0",
            "textAlign": "left"
          }
        },
        "outerCss": {
          "backgroundColor": "#ffffff",
          "justifyContent": "space-between",
          "alignItems": "center",
          "textAlign": "left",
          "padding": "4px 8px",
          "boxSizing": "border-box",
          "display": "flex",
          "flexDirection": "row",
          "gap": "4px"
        },
        "default_fields": {},
        "is_default_value": false,
        "add_display_name": true
      },
      {
        "id": "block-grand-total",
        "type": "paragraph",
        "display_name": "Grand Total Price",
        "data": {
          "elements": [
            {
              "field": "text",
              "value": "$36.50"
            },
            {
              "field": "display_name",
              "value": "Grand Total Price"
            }
          ]
        },
        "css": {
          "paragraph": {
            "fontSize": "16px",
            "fontWeight": "700",
            "color": "#1a1a1a",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif",
            "boxSizing": "border-box",
            "textAlign": "left"
          },
          "displayName": {
            "fontSize": "16px",
            "fontWeight": "700",
            "color": "#1a1a1a",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif",
            "textAlign": "left"
          },
          "displayNameContainer": {
            "padding": "0",
            "backgroundColor": "transparent",
            "margin": "0",
            "textAlign": "left"
          }
        },
        "outerCss": {
          "backgroundColor": "#f5f5f5",
          "justifyContent": "space-between",
          "alignItems": "center",
          "textAlign": "left",
          "padding": "8px",
          "boxSizing": "border-box",
          "display": "flex",
          "flexDirection": "row",
          "gap": "4px",
          "borderTop": "1px solid #e0e0e0",
          "borderBottom": "1px solid #e0e0e0"
        },
        "default_fields": {},
        "is_default_value": false,
        "add_display_name": true
      },
      {
        "id": "block-checkout-button",
        "type": "button",
        "display_name": "Proceed to Payment",
        "data": {
          "elements": [
            {
              "field": "text",
              "value": "Proceed to Payment"
            },
            {
              "field": "url",
              "value": "#"
            },
            {
              "field": "display_name",
              "value": "Proceed to Payment"
            }
          ]
        },
        "css": {
          "button": {
            "backgroundColor": "#1976d2",
            "color": "#ffffff",
            "padding": "8px 16px",
            "borderRadius": "8px",
            "fontSize": "16px",
            "fontFamily": "'Inter', sans-serif",
            "fontWeight": "600",
            "textTransform": "none",
            "boxSizing": "border-box",
            "transition": "background-color 0.3s ease",
            "cursor": "pointer",
            "width": "100%",
            "border": "none"
          },
          "buttonHover": {
            "backgroundColor": "#1565c0"
          },
          "displayName": {
            "fontSize": "14px",
            "fontWeight": "500",
            "color": "#1a1a1a",
            "margin": "0",
            "fontFamily": "'Inter', sans-serif"
          },
          "displayNameContainer": {
            "padding": "0",
            "backgroundColor": "transparent",
            "margin": "0"
          }
        },
        "outerCss": {
          "backgroundColor": "#ffffff",
          "justifyContent": "center",
          "alignItems": "center",
          "textAlign": "center",
          "padding": "8px",
          "boxSizing": "border-box",
          "display": "flex",
          "flexDirection": "column",
          "gap": "4px"
        },
        "default_fields": {},
        "is_default_value": false,
        "add_display_name": false
      }
    ]
  }
}
  ,
  {
    uiName: "Google Maps",
    artifact_id: "a1b2c3d4-e5f6-7890-1234-567890abcdef",
    title: "Google Maps",
    contentType: "application/json",
    data: {
      time: 1749903900000,
      blocks: [
   {
        "id": "block-hotel-royal-radiant-image",
        "type": "image",
        "display_name": "image",
        "data": {
            "elements": [
                {
                    "field": "files",
                    "value": [
                        {
                            "url": "https://encrypted-tbn2.gstatic.com/licensed-image?q=tbn:ANd9GcThN2LFRMAXS4YXsLzfeEg32mjEShnJpjUvciIN24u9w1N7sAkegBYuDKD8mm0AoDFgkwsYef3azDmlBINXy_qgQcpr7VSPw6s8pZUY5g"
                        }
                    ]
                },
                {
                    "field": "display_name",
                    "value": "image"
                }
            ]
        },
        "css": {
            "image": {
                "width": "100%",
                "height": "210px",
                "objectFit": "cover",
                "borderRadius": "8px",
                "margin": "0 0 0px 0",
                "boxSizing": "border-box",
                "alignSelf": "center",
                "boxShadow": "none",
                "transition": "all 0.3s ease",
               
            },
            "displayName": {
                "fontSize": "16px",
                "fontWeight": "600",
                "color": "#333333",
                "marginBottom": "0px",
                "fontFamily": "'Arial', sans-serif",
                "transition": "all 0.3s ease"
            },
            "displayNameContainer": {
                "padding": "0px",
                "backgroundColor": "transparent",
                "borderRadius": "4px",
                "marginBottom": "0px",
                "transition": "all 0.3s ease"
            }
        },
        "outerCss": {
            "backgroundColor": "#f5f5f5",
            "justifyContent": "center",
            "alignItems": "center",
            "textAlign": "center",
            // "padding": "0px",
            "boxShadow": "0 4px 8px rgba(0, 0, 0, 0.1)",
            "boxSizing": "border-box",
            "display": "flex",
            "flexDirection": "column",
            "gap": "0px",
             padding:"8px",
              borderRadius: '10px 10px 0 0 '
        },
        "default_fields": {},
        "is_default_value": false,
        "add_display_name": false
    },
    {
        "id": "block-hotel-royal-radiant-title",
        "type": "header",
        "display_name": "Hotel Royal Radiant -",
        "data": {
            "elements": [
                {
                    "field": "text",
                    "value": "Hotel Royal Radiant "
                },
                {
                    "field": "display_name",
                    "value": "name"
                }
            ]
        },
        "css": {
            "header": {
                "color": "#333333",
                "fontWeight": "700",
                "margin": "0",
                "fontFamily": "'Arial', sans-serif",
                "fontSize": "18px",
                "boxSizing": "border-box",
                "transition": "all 0.3s ease"
            },
            "displayName": {
                "fontSize": "16px",
                "fontWeight": "600",
                "color": "#333333",
                "marginBottom": "8px",
                "fontFamily": "'Arial', sans-serif",
                "transition": "all 0.3s ease"
            },
            "displayNameContainer": {
                "padding": "8px",
                "backgroundColor": "transparent",
                "borderRadius": "4px",
                "marginBottom": "8px",
                "transition": "all 0.3s ease",
                "textAlign": "center"
            }
        },
        "outerCss": {
            "backgroundColor": "#f5f5f5",
            "justifyContent": "center",
            "alignItems": "flex-start",
            "padding": "5px",
            "textAlign": "center",
            "boxShadow": "0 4px 8px rgba(0, 0, 0, 0.1)",
            "boxSizing": "border-box",
            "display": "flex",
            "flexDirection": "row",
            "gap": "8px"
        },
        "default_fields": {},
        "is_default_value": false,
        "add_display_name": false
    },
    
    {
        "id": "block-hotel-royal-radiant-address",
        "type": "paragraph",
        "display_name": "Address",
        "data": {
            "elements": [
                {
                    "field": "text",
                    "value": "W Market Rd, Ward Number 20, Upper Bazar, Ranchi, Jharkhand 834001, India"
                },
                {
                    "field": "display_name",
                    "value": "Address"
                }
            ]
        },
        "css": {
            "paragraph": {
                "color": "#666666",
                "fontSize": "14px",
                "margin": "0",
                "fontFamily": "'Arial', sans-serif",
                "boxSizing": "border-box",
                "transition": "all 0.3s ease",
                "textAlign": "center"
            },
            "displayName": {
                "fontSize": "14px",
                "fontWeight": "600",
                "color": "#333333",
                "marginBottom": "8px",
                "fontFamily": "'Arial', sans-serif",
                "transition": "all 0.3s ease"
            },
            "displayNameContainer": {
                "padding": "8px",
                "backgroundColor": "transparent",
                "borderRadius": "4px",
                "marginBottom": "0px",
                "transition": "all 0.3s ease"
            }
        },
        "outerCss": {
            "backgroundColor": "#f5f5f5",
            "justifyContent": "flex-start",
            "alignItems": "flex-start",
            "textAlign": "center",
            "padding": "0px 5px 0 5px",
            "boxShadow": "0 4px 8px rgba(0, 0, 0, 0.1)",
            "boxSizing": "border-box",
            "display": "flex",
            "flexDirection": "row",
            "gap": "8px"
        },
        "default_fields": {},
        "is_default_value": false,
        "add_display_name": false
    },
    {
        "id": "block-hotel-royal-radiant-rating",
        "type": "paragraph",
        "display_name": "Rating",
        "data": {
            "elements": [
                {
                    "field": "text",
                    "value": "4.8 (276 reviews)"
                },
                {
                    "field": "display_name",
                    "value": "Rating"
                }
            ]
        },
        "css": {
            "paragraph": {
                "fontSize": "14px",
                "fontWeight": "600",
                "color": "#007BFF",
                "margin": "0",
                "fontFamily": "'Arial', sans-serif",
                "boxSizing": "border-box",
                "textTransform": "none",
                "transition": "all 0.3s ease"
            },
            "displayName": {
                "fontSize": "14px",
                "fontWeight": "600",
                "color": "#007BFF",
                "marginBottom": "0px",
                "fontFamily": "'Arial', sans-serif",
                "transition": "all 0.3s ease"
            },
            "displayNameContainer": {
                "padding": "1px",
                "backgroundColor": "transparent",
                // "borderRadius": "4px",
                "marginBottom": "0px",
                "transition": "all 0.3s ease"
            }
        },
        "outerCss": {
            "backgroundColor": "#f5f5f5",
            "justifyContent": "center",
            "alignItems": "center",
            "textAlign": "left",
            "padding": "0px",
            "color": "blue",
            "boxShadow": "0 4px 8px rgba(0, 0, 0, 0.1)",
            "boxSizing": "border-box",
            "display": "flex",
            "flexDirection": "row",
            "gap": "2px"
        },
        "default_fields": {},
        "is_default_value": false,
        "add_display_name": true
    },
    
    {
        "id": "block-hotel-royal-radiant-button",
        "type": "button",
        "display_name": "View Details",
        "data": {
            "elements": [
                {
                    "field": "text",
                    "value": "View Details"
                },
                {
                    "field": "url",
                    "value": "https://maps.google.com/?q=ChIJ51l0TbXh9DkR5JmnQhGhyak"
                },
                {
                    "field": "display_name",
                    "value": "View Details"
                }
            ]
        },
        "css": {
            "button": {
                "backgroundColor": "#007BFF",
                "color": "#ffffff",
                "padding": "8px 16px",
                "borderRadius": "8px",
                "fontSize": "14px",
                "fontFamily": "'Arial', sans-serif",
                "textTransform": "uppercase",
                "boxSizing": "border-box",
                "boxShadow": "0 2px 4px rgba(0, 0, 0, 0.2)",
                "transition": "all 0.3s ease",
                "cursor": "pointer",
                "width": "100%"
            },
            "buttonHover": {
                "backgroundColor": "#1565c0"
            },
            "displayName": {
                "fontSize": "16px",
                "fontWeight": "600",
                "color": "#333333",
                "marginBottom": "0px",
                "fontFamily": "'Arial', sans-serif",
                "transition": "all 0.3s ease"
            },
            "displayNameContainer": {
                "padding": "0px",
                "backgroundColor": "transparent",
                "borderRadius": "4px",
                "marginBottom": "0px",
                "transition": "all 0.3s ease"
            }
        },
        "outerCss": {
            "backgroundColor": "#f5f5f5",
            "justifyContent": "center",
            "alignItems": "center",
            "textAlign": "center",
            "padding": "5px",
            "boxShadow": "0 4px 8px rgba(0, 0, 0, 0.1)",
            "boxSizing": "border-box",
            "display": "flex",
            "flexDirection": "row",
            "gap": "8px",
            borderRadius: '0 0 10px 10px'
        },
        "default_fields": {},
        "is_default_value": false,
        "add_display_name": false
    },


   
    
]

    }

  },
//   {
//     uiName: "Google Maps",
//     artifact_id: "a1b2c3d4-e5f6-7890-1234-567890abcdef",
//     title: "Google Maps",
//     contentType: "application/json",
//     data: {
//       time: 1749903900000,
//       blocks: [
//    {
//         "id": "block-hotel-royal-radiant-image",
//         "type": "image",
//         "display_name": "image",
//         "data": {
//             "elements": [
//                 {
//                     "field": "files",
//                     "value": [
//                         {
//                             "url": "https://media.istockphoto.com/id/184946701/photo/pizza.jpg?s=612x612&w=0&k=20&c=97rc0VIi-s3mn4xe4xDy9S-XJ_Ohbn92XaEMaiID_eY="
//                         }
//                     ]
//                 },
//                 {
//                     "field": "display_name",
//                     "value": "image"
//                 }
//             ]
//         },
//         "css": {
//             "image": {
//                 "width": "100%",
//                 "height": "150px",
//                 "objectFit": "cover",
//                 "borderRadius": "8px",
//                 "margin": "0 0 0px 0",
//                 "boxSizing": "border-box",
//                 "alignSelf": "center",
//                 "boxShadow": "0 2px 4px rgba(0, 0, 0, 0.1)",
//                 "transition": "all 0.3s ease"
//             },
//             "displayName": {
//                 "fontSize": "16px",
//                 "fontWeight": "600",
//                 "color": "#333333",
//                 "marginBottom": "0px",
//                 "fontFamily": "'Arial', sans-serif",
//                 "transition": "all 0.3s ease"
//             },
//             "displayNameContainer": {
//                 "padding": "0px",
//                 "backgroundColor": "transparent",
//                 "borderRadius": "4px",
//                 "marginBottom": "0px",
//                 "transition": "all 0.3s ease"
//             }
//         },
//         "outerCss": {
//             "backgroundColor": "#f5f5f5",
//             "justifyContent": "center",
//             "alignItems": "center",
//             "textAlign": "center",
//             "padding": "0px",
//             "boxShadow": "0 4px 8px rgba(0, 0, 0, 0.1)",
//             "boxSizing": "border-box",
//             "display": "flex",
//             "flexDirection": "column",
//             "gap": "0px"
//         },
//         "default_fields": {},
//         "is_default_value": false,
//         "add_display_name": false
//     },
//     {
//         "id": "block-hotel-royal-radiant-title",
//         "type": "header",
//         "display_name": "Hotel Royal Radiant -",
//         "data": {
//             "elements": [
//                 {
//                     "field": "text",
//                     "value": "Hotel Royal Radiant -"
//                 },
//                 {
//                     "field": "display_name",
//                     "value": "name"
//                 }
//             ]
//         },
//         "css": {
//             "header": {
//                 "color": "#333333",
//                 "fontWeight": "700",
//                 "margin": "0",
//                 "fontFamily": "'Arial', sans-serif",
//                 "fontSize": "18px",
//                 "boxSizing": "border-box",
//                 "transition": "all 0.3s ease"
//             },
//             "displayName": {
//                 "fontSize": "16px",
//                 "fontWeight": "600",
//                 "color": "#333333",
//                 "marginBottom": "8px",
//                 "fontFamily": "'Arial', sans-serif",
//                 "transition": "all 0.3s ease"
//             },
//             "displayNameContainer": {
//                 "padding": "8px",
//                 "backgroundColor": "transparent",
//                 "borderRadius": "4px",
//                 "marginBottom": "8px",
//                 "transition": "all 0.3s ease",
//                 "textAlign": "center"
//             }
//         },
//         "outerCss": {
//             "backgroundColor": "#f5f5f5",
//             "justifyContent": "center",
//             "alignItems": "flex-start",
//             "padding": "5px",
//             "textAlign": "center",
//             "boxShadow": "0 4px 8px rgba(0, 0, 0, 0.1)",
//             "boxSizing": "border-box",
//             "display": "flex",
//             "flexDirection": "row",
//             "gap": "8px"
//         },
//         "default_fields": {},
//         "is_default_value": false,
//         "add_display_name": false
//     },
//     //  {
//     //       id: "block-6f789012-3456-7890-abcd-ef1234567890",
//     //       type: "map",
//     //       display_name: "Hotel Location",
//     //       data: {
//     //         elements: [
//     //           {
//     //             field: "lat",
//     //             value: "37.7749",
//     //           },
//     //           {
//     //             field: "lng",
//     //             value: "-122.4194",
//     //           },
//     //           {
//     //             field: "display_name",
//     //             value: "Hotel Location",
//     //           },
//     //         ],
//     //       },
//     //       css: {
//     //         map: {
//     //           margin: "12px 0",
//     //           borderRadius: "6px",
//     //           height: "200px",
//     //           //"maxWidth": "200px",
//     //           width: "100%",
//     //           boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
//     //           transition: "all 0.3s ease",
//     //         },
//     //         displayName: {
//     //           fontSize: "16px",
//     //           fontWeight: "600",
//     //           color: "#0d3b66",
//     //           marginBottom: "8px",
//     //           fontFamily: "'Roboto', Arial, sans-serif",
//     //           transition: "all 0.3s ease",
//     //         },
//     //         displayNameContainer: {
//     //           padding: "8px",
//     //           backgroundColor: "#e6f0fa",
//     //           borderRadius: "4 znów px",
//     //           marginBottom: "8px",
//     //           transition: "all 0.3s ease",
//     //         },
//     //       },
//     //       outerCss: {
//     //         backgroundColor: "#f9fcff",
//     //         justifyContent: "flex-start",
//     //         alignItems: "flex-start",
//     //         textAlign: "left",
//     //       },
//     //       default_fields: {},
//     //       is_default_value: false,
//     //       add_display_name: true,
//     //     },
//     {
//         "id": "block-hotel-royal-radiant-address",
//         "type": "paragraph",
//         "display_name": "Address",
//         "data": {
//             "elements": [
//                 {
//                     "field": "text",
//                     "value": "W Market Rd, Ward Number 20, Upper Bazar, Ranchi, Jharkhand 834001, India"
//                 },
//                 {
//                     "field": "display_name",
//                     "value": "Address"
//                 }
//             ]
//         },
//         "css": {
//             "paragraph": {
//                 "color": "#666666",
//                 "fontSize": "14px",
//                 "margin": "0",
//                 "fontFamily": "'Arial', sans-serif",
//                 "boxSizing": "border-box",
//                 "transition": "all 0.3s ease",
//                 "textAlign": "center"
//             },
//             "displayName": {
//                 "fontSize": "14px",
//                 "fontWeight": "600",
//                 "color": "#333333",
//                 "marginBottom": "8px",
//                 "fontFamily": "'Arial', sans-serif",
//                 "transition": "all 0.3s ease"
//             },
//             "displayNameContainer": {
//                 "padding": "8px",
//                 "backgroundColor": "transparent",
//                 "borderRadius": "4px",
//                 "marginBottom": "0px",
//                 "transition": "all 0.3s ease"
//             }
//         },
//         "outerCss": {
//             "backgroundColor": "#f5f5f5",
//             "justifyContent": "flex-start",
//             "alignItems": "flex-start",
//             "textAlign": "center",
//             "padding": "0px",
//             "boxShadow": "0 4px 8px rgba(0, 0, 0, 0.1)",
//             "boxSizing": "border-box",
//             "display": "flex",
//             "flexDirection": "row",
//             "gap": "8px"
//         },
//         "default_fields": {},
//         "is_default_value": false,
//         "add_display_name": true
//     },
//     {
//         "id": "block-hotel-royal-radiant-rating",
//         "type": "paragraph",
//         "display_name": "Rating",
//         "data": {
//             "elements": [
//                 {
//                     "field": "text",
//                     "value": "4.8 (276 reviews)"
//                 },
//                 {
//                     "field": "display_name",
//                     "value": "Rating"
//                 }
//             ]
//         },
//         "css": {
//             "paragraph": {
//                 "fontSize": "16px",
//                 "fontWeight": "600",
//                 "color": "#007BFF",
//                 "margin": "0 0 0px 0",
//                 "fontFamily": "'Arial', sans-serif",
//                 "boxSizing": "border-box",
//                 "textTransform": "none",
//                 "transition": "all 0.3s ease"
//             },
//             "displayName": {
//                 "fontSize": "16px",
//                 "fontWeight": "600",
//                 "color": "#007BFF",
//                 "marginBottom": "0px",
//                 "fontFamily": "'Arial', sans-serif",
//                 "transition": "all 0.3s ease"
//             },
//             "displayNameContainer": {
//                 "padding": "1px",
//                 "backgroundColor": "transparent",
//                 "borderRadius": "4px",
//                 "marginBottom": "0px",
//                 "transition": "all 0.3s ease"
//             }
//         },
//         "outerCss": {
//             "backgroundColor": "#f5f5f5",
//             "justifyContent": "center",
//             "alignItems": "center",
//             "textAlign": "left",
//             "padding": "0px",
//             "color": "blue",
//             "boxShadow": "0 4px 8px rgba(0, 0, 0, 0.1)",
//             "boxSizing": "border-box",
//             "display": "flex",
//             "flexDirection": "row",
//             "gap": "2px"
//         },
//         "default_fields": {},
//         "is_default_value": false,
//         "add_display_name": true
//     },
    
//     {
//         "id": "block-hotel-royal-radiant-button",
//         "type": "button",
//         "display_name": "View Details",
//         "data": {
//             "elements": [
//                 {
//                     "field": "text",
//                     "value": "View Details"
//                 },
//                 {
//                     "field": "url",
//                     "value": "https://maps.google.com/?q=ChIJ51l0TbXh9DkR5JmnQhGhyak"
//                 },
//                 {
//                     "field": "display_name",
//                     "value": "View Details"
//                 }
//             ]
//         },
//         "css": {
//             "button": {
//                 "backgroundColor": "#007BFF",
//                 "color": "#ffffff",
//                 "padding": "8px 16px",
//                 "borderRadius": "8px",
//                 "fontSize": "14px",
//                 "fontFamily": "'Arial', sans-serif",
//                 "textTransform": "uppercase",
//                 "boxSizing": "border-box",
//                 "boxShadow": "0 2px 4px rgba(0, 0, 0, 0.2)",
//                 "transition": "all 0.3s ease",
//                 "cursor": "pointer",
//                 "width": "100%"
//             },
//             "buttonHover": {
//                 "backgroundColor": "#1565c0"
//             },
//             "displayName": {
//                 "fontSize": "16px",
//                 "fontWeight": "600",
//                 "color": "#333333",
//                 "marginBottom": "0px",
//                 "fontFamily": "'Arial', sans-serif",
//                 "transition": "all 0.3s ease"
//             },
//             "displayNameContainer": {
//                 "padding": "0px",
//                 "backgroundColor": "transparent",
//                 "borderRadius": "4px",
//                 "marginBottom": "0px",
//                 "transition": "all 0.3s ease"
//             }
//         },
//         "outerCss": {
//             "backgroundColor": "#f5f5f5",
//             "justifyContent": "center",
//             "alignItems": "center",
//             "textAlign": "center",
//             "padding": "5px",
//             "boxShadow": "0 4px 8px rgba(0, 0, 0, 0.1)",
//             "boxSizing": "border-box",
//             "display": "flex",
//             "flexDirection": "row",
//             "gap": "8px"
//         },
//         "default_fields": {},
//         "is_default_value": false,
//         "add_display_name": false
//     },


   
    
// ]

//     }

//   },



  {
    uiName: "Pizza menu",
    artifact_id: "a1b2c3d4-e5f6-7890-1234-567890abcdef",
    title: "Pizza Menu",
    contentType: "application/json",
    data: {
      time: 1749903900000,
      blocks: [
         {
    "id": "block-margherita-image",
    "type": "image",
    "display_name": "image",
    "data": {
      "elements": [
        {
          "field": "files",
          "value": [
            {
              "url": "https://media.istockphoto.com/id/184946701/photo/pizza.jpg?s=612x612&w=0&k=20&c=97rc0VIi-s3mn4xe4xDy9S-XJ_Ohbn92XaEMaiID_eY="
            }
          ]
        },
        {
          "field": "display_name",
          "value": "image"
        }
      ]
    },
    "css": {
      "image": {
        "width": "100%",
        "height": "150px",
        "objectFit": "cover",
        "borderRadius": "8px",
        "margin": "0 0 0px 0",
        "boxSizing": "border-box",
        "alignSelf": "center",
        "boxShadow": "0 2px 4px rgba(0, 0, 0, 0.1)",
        "transition": "all 0.3s ease"
      },
      "displayName": {
        "fontSize": "16px",
        "fontWeight": "600",
        "color": "#333333",
        "marginBottom": "0px",
        "fontFamily": "'Arial', sans-serif",
        "transition": "all 0.3s ease"
      },
      "displayNameContainer": {
        "padding": "0px",
        "backgroundColor": "transparent",
        "borderRadius": "4px",
        "marginBottom": "0px",
        "transition": "all 0.3s ease"
      }
    },
    "outerCss": {
      "backgroundColor": "#f5f5f5",
      "justifyContent": "center",
      "alignItems": "center",
      "textAlign": "center",
      // "padding": "0px",
     
      
      "boxShadow": "0 4px 8px rgba(0, 0, 0, 0.1)",
      
      
      "boxSizing": "border-box",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0px"
      ,
      borderStyle: 'solid',
  borderWidth: '2px 2px 0px 2px',
  borderColor: 'rgb(100, 3, 95)',
   "padding": "8px",
   "paddingBottom": "0px",
   borderRadius: '10px 10px 0 0'
    },
    "default_fields": {},
    "is_default_value": false,
    "add_display_name": false
  },
  {
    "id": "block-margherita-title",
    "type": "header",
    "display_name": "Margherita - Small",
    "data": {
      "elements": [
        {
          "field": "text",
          "value": "Margherita - Small "
        },
        {
          "field": "display_name",
          "value": "name"
        }
      ]
    },
    "css": {
      "header": {
        "color": "#333333",
        "fontWeight": "700",
        "margin": "0",
        "fontFamily": "'Arial', sans-serif",
        "fontSize": "17px",
        "boxSizing": "border-box",
        "transition": "all 0.3s ease",
       
      },
      "displayName": {
        "fontSize": "16px",
        "fontWeight": "600",
        "color": "#333333",
        "marginBottom": "8px",
        "fontFamily": "'Arial', sans-serif",
        "transition": "all 0.3s ease"
      },
      "displayNameContainer": {
        "padding": "8px",
        "backgroundColor": "transparent",
        "borderRadius": "4px",
        "marginBottom": "8px",
        "transition": "all 0.3s ease",
        "textAlign":"center"
      }
    },
    "outerCss": {
      "backgroundColor": "#f5f5f5",
      "justifyContent": "center",
      "alignItems": "flex-start",
    
      // "padding": "5px",
     
       "textAlign":"center",
      "boxShadow": "0 4px 8px rgba(0, 0, 0, 0.1)",
      
      
      "boxSizing": "border-box",
      "display": "flex",
      "flexDirection": "row",
     
      "gap": "8px",
      borderStyle: 'solid',
  borderWidth: '0px 2px 0px 2px',
  borderColor: 'rgb(100, 3, 95)',
   "padding": "8px",
   "paddingBottom": "0px",

    },
    "default_fields": {},
    "is_default_value": false,
    "add_display_name": false
  },
  {
    "id": "block-margherita-description",
    "type": "paragraph",
    "display_name": "description",
    "data": {
      "elements": [
        {
          "field": "text",
          "value": "A classic pizza with fresh mozzarella, tomatoes, and basil."
        },
        {
          "field": "display_name",
          "value": "description"
        }
      ]
    },
    "css": {
      "paragraph": {
        "color": "#666666",
        "fontSize": "14px",
        "margin": "0",
        "fontFamily": "'Arial', sans-serif",
        "boxSizing": "border-box",
        "transition": "all 0.3s ease",
        "textAlign": "center",
         
      },
      "displayName": {
        "fontSize": "14px",
        "fontWeight": "600",
        "color": "#333333",
        "marginBottom": "8px",
        "fontFamily": "'Arial', sans-serif",
        "transition": "all 0.3s ease"
      },
      "displayNameContainer": {
        "padding": "8px",
        "backgroundColor": "transparent",
        "borderRadius": "4px",
        "marginBottom": "0px",
        "transition": "all 0.3s ease"
      }
    },
    "outerCss": {
      "backgroundColor": "#f5f5f5",
      "justifyContent": "center",
      "alignItems": "flex-start",
      "textAlign": "center",
    
     
      
      "boxShadow": "0 4px 8px rgba(0, 0, 0, 0.1)",
      
      
      "boxSizing": "border-box",
      "display": "flex",
      "flexDirection": "row",
      "gap": "8px",
      borderStyle: 'solid',
  borderWidth: '0px 2px 0px 2px',
  borderColor: 'rgb(100, 3, 95)',
   "padding": "8px",
   "paddingBottom": "0px",
    },
    "default_fields": {},
    "is_default_value": false,
    "add_display_name": false
  },
 
 
  {
    "id": "block-margherita-button",
    "type": "button",
    "display_name": "Choose",
    "data": {
      "elements": [
        {
          "field": "text",
          "value": "Choose →"
        },
        {
          "field": "url",
          "value": "#"
        },
        {
          "field": "display_name",
          "value": "Choose"
        }
      ]
    },
    "css": {
      "button": {
        "backgroundColor": "transparent",
        "color": "rgb(100, 3, 95)",
        "padding": "0",
        "borderRadius": "8px",
        "fontSize": "14px",
        "fontFamily": "'Arial', sans-serif",
        "textTransform": "uppercase",
        "boxSizing": "border-box",
        "boxShadow": "none",
        "transition": "all 0.3s ease",
        "cursor": "pointer",
        width:"auto"
      },
      "buttonHover": {
        "backgroundColor": "#1565c0"
      },
      "displayName": {
        "fontSize": "16px",
        "fontWeight": "600",
        "color": "rgb(100, 3, 95)",
        "marginBottom": "0px",
        "fontFamily": "'Arial', sans-serif",
        "transition": "all 0.3s ease"
      },
      "displayNameContainer": {
        "padding": "0px",
        "backgroundColor": "transparent",
        "borderRadius": "4px",
        "marginBottom": "0px",
        "transition": "all 0.3s ease"
      }
    },
    "outerCss": {
      "backgroundColor": "#f5f5f5",
      "justifyContent": "center",
      "alignItems": "center",
      "textAlign": "center",
     
     
      
      "boxShadow": "0 4px 8px rgba(0, 0, 0, 0.1)",
      
      
      "boxSizing": "border-box",
      "display": "flex",
      "flexDirection": "0px",
      "gap": "8px",
      borderStyle: 'solid',
  borderWidth: '0px 2px 2px 2px',
  borderColor: 'rgb(100, 3, 95)',
   "padding": "8px",
    borderRadius: '0 0 10px 10px'

    },
    "default_fields": {},
    "is_default_value": false,
    "add_display_name": false
  }
],
    },
  },
//   {
//     uiName: "Pizza menu",
//     artifact_id: "a1b2c3d4-e5f6-7890-1234-567890abcdef",
//     title: "Pizza Menu",
//     contentType: "application/json",
//     data: {
//       time: 1749903900000,
//       blocks: [
//   {
//     "id": "block-margherita-title",
//     "type": "header",
//     "display_name": "Margherita - Small",
//     "data": {
//       "elements": [
//         {
//           "field": "text",
//           "value": "Margherita - Small"
//         },
//         {
//           "field": "display_name",
//           "value": "name"
//         }
//       ]
//     },
//     "css": {
//       "header": {
//         "color": "#333333",
//         "fontWeight": "700",
//         "margin": "0",
//         "fontFamily": "'Arial', sans-serif",
//         "fontSize": "18px",
//         "boxSizing": "border-box",
//         "transition": "all 0.3s ease",
       
//       },
//       "displayName": {
//         "fontSize": "16px",
//         "fontWeight": "600",
//         "color": "#333333",
//         "marginBottom": "8px",
//         "fontFamily": "'Arial', sans-serif",
//         "transition": "all 0.3s ease"
//       },
//       "displayNameContainer": {
//         "padding": "8px",
//         "backgroundColor": "transparent",
//         "borderRadius": "4px",
//         "marginBottom": "8px",
//         "transition": "all 0.3s ease",
//         "textAlign":"center"
//       }
//     },
//     "outerCss": {
//       "backgroundColor": "#f5f5f5",
//       "justifyContent": "center",
//       "alignItems": "flex-start",
    
//       "padding": "5px",
     
//        "textAlign":"center",
//       "boxShadow": "0 4px 8px rgba(0, 0, 0, 0.1)",
      
      
//       "boxSizing": "border-box",
//       "display": "flex",
//       "flexDirection": "row",
//       "gap": "8px"
//     },
//     "default_fields": {},
//     "is_default_value": false,
//     "add_display_name": false
//   },
//   {
//     "id": "block-margherita-description",
//     "type": "paragraph",
//     "display_name": "description",
//     "data": {
//       "elements": [
//         {
//           "field": "text",
//           "value": "A classic pizza with fresh mozzarella, tomatoes, and basil."
//         },
//         {
//           "field": "display_name",
//           "value": "description"
//         }
//       ]
//     },
//     "css": {
//       "paragraph": {
//         "color": "#666666",
//         "fontSize": "14px",
//         "margin": "0",
//         "fontFamily": "'Arial', sans-serif",
//         "boxSizing": "border-box",
//         "transition": "all 0.3s ease",
//         "textAlign": "center",
//       },
//       "displayName": {
//         "fontSize": "14px",
//         "fontWeight": "600",
//         "color": "#333333",
//         "marginBottom": "8px",
//         "fontFamily": "'Arial', sans-serif",
//         "transition": "all 0.3s ease"
//       },
//       "displayNameContainer": {
//         "padding": "8px",
//         "backgroundColor": "transparent",
//         "borderRadius": "4px",
//         "marginBottom": "0px",
//         "transition": "all 0.3s ease"
//       }
//     },
//     "outerCss": {
//       "backgroundColor": "#f5f5f5",
//       "justifyContent": "flex-start",
//       "alignItems": "flex-start",
//       "textAlign": "center",
//       "padding": "0px",
     
      
//       "boxShadow": "0 4px 8px rgba(0, 0, 0, 0.1)",
      
      
//       "boxSizing": "border-box",
//       "display": "flex",
//       "flexDirection": "row",
//       "gap": "8px"
//     },
//     "default_fields": {},
//     "is_default_value": false,
//     "add_display_name": false
//   },
//   {
//     "id": "block-margherita-price",
//     "type": "paragraph",
//     "display_name": "Base Price",
//     "data": {
//       "elements": [
//         {
//           "field": "text",
//           "value": "8"
//         },
//         {
//           "field": "display_name",
//           "value": "Base Price"
//         }
//       ]
//     },
//     "css": {
//       "paragraph": {
      
//         "fontSize": "16px",
//         "fontWeight": "600",
//         "color":"#007BFF",
//         "margin": "0 0 0px 0",
//         "fontFamily": "'Arial', sans-serif",
//         "boxSizing": "border-box",
//         "textTransform": "none",
//         "transition": "all 0.3s ease"
//       },
//       "displayName": {
//         "fontSize": "16px",
//         "fontWeight": "600",
//         "color": "#007BFF",
//         "marginBottom": "0px",
//         "fontFamily": "'Arial', sans-serif",
//         "transition": "all 0.3s ease"
//       },
//       "displayNameContainer": {
//         "padding": "1px",
//         "backgroundColor": "transparent",
//         "borderRadius": "4px",
//         "marginBottom": "0px",
//         "transition": "all 0.3s ease"
//       }
//     },
//     "outerCss": {
//       "backgroundColor": "#f5f5f5",
//       "justifyContent": "center",
//       "alignItems": "center",
//       "textAlign": "left",
//       "padding": "0px",
     
//       "color":"blue",
//       "boxShadow": "0 4px 8px rgba(0, 0, 0, 0.1)",
      
      
//       "boxSizing": "border-box",
//       "display": "flex",
//       "flexDirection": "row",
//       "gap": "2px"
//     },
//     "default_fields": {},
//     "is_default_value": false,
//     "add_display_name": true
//   },
//   {
//     "id": "block-margherita-image",
//     "type": "image",
//     "display_name": "image",
//     "data": {
//       "elements": [
//         {
//           "field": "files",
//           "value": [
//             {
//               "url": "https://media.istockphoto.com/id/184946701/photo/pizza.jpg?s=612x612&w=0&k=20&c=97rc0VIi-s3mn4xe4xDy9S-XJ_Ohbn92XaEMaiID_eY="
//             }
//           ]
//         },
//         {
//           "field": "display_name",
//           "value": "image"
//         }
//       ]
//     },
//     "css": {
//       "image": {
//         "width": "100%",
//         "height": "150px",
//         "objectFit": "cover",
//         "borderRadius": "8px",
//         "margin": "0 0 0px 0",
//         "boxSizing": "border-box",
//         "alignSelf": "center",
//         "boxShadow": "0 2px 4px rgba(0, 0, 0, 0.1)",
//         "transition": "all 0.3s ease"
//       },
//       "displayName": {
//         "fontSize": "16px",
//         "fontWeight": "600",
//         "color": "#333333",
//         "marginBottom": "0px",
//         "fontFamily": "'Arial', sans-serif",
//         "transition": "all 0.3s ease"
//       },
//       "displayNameContainer": {
//         "padding": "0px",
//         "backgroundColor": "transparent",
//         "borderRadius": "4px",
//         "marginBottom": "0px",
//         "transition": "all 0.3s ease"
//       }
//     },
//     "outerCss": {
//       "backgroundColor": "#f5f5f5",
//       "justifyContent": "center",
//       "alignItems": "center",
//       "textAlign": "center",
//       "padding": "0px",
     
      
//       "boxShadow": "0 4px 8px rgba(0, 0, 0, 0.1)",
      
      
//       "boxSizing": "border-box",
//       "display": "flex",
//       "flexDirection": "column",
//       "gap": "0px"
//     },
//     "default_fields": {},
//     "is_default_value": false,
//     "add_display_name": false
//   },
//   {
//     "id": "block-margherita-button",
//     "type": "button",
//     "display_name": "Choose",
//     "data": {
//       "elements": [
//         {
//           "field": "text",
//           "value": "Choose"
//         },
//         {
//           "field": "url",
//           "value": "#"
//         },
//         {
//           "field": "display_name",
//           "value": "Choose"
//         }
//       ]
//     },
//     "css": {
//       "button": {
//         "backgroundColor": "#007BFF",
//         "color": "#ffffff",
//         "padding": "8px 16px",
//         "borderRadius": "8px",
//         "fontSize": "14px",
//         "fontFamily": "'Arial', sans-serif",
//         "textTransform": "uppercase",
//         "boxSizing": "border-box",
//         "boxShadow": "0 2px 4px rgba(0, 0, 0, 0.2)",
//         "transition": "all 0.3s ease",
//         "cursor": "pointer",
//         width:"100%"
//       },
//       "buttonHover": {
//         "backgroundColor": "#1565c0"
//       },
//       "displayName": {
//         "fontSize": "16px",
//         "fontWeight": "600",
//         "color": "#333333",
//         "marginBottom": "0px",
//         "fontFamily": "'Arial', sans-serif",
//         "transition": "all 0.3s ease"
//       },
//       "displayNameContainer": {
//         "padding": "0px",
//         "backgroundColor": "transparent",
//         "borderRadius": "4px",
//         "marginBottom": "0px",
//         "transition": "all 0.3s ease"
//       }
//     },
//     "outerCss": {
//       "backgroundColor": "#f5f5f5",
//       "justifyContent": "center",
//       "alignItems": "center",
//       "textAlign": "center",
//       "padding": "5px",
     
      
//       "boxShadow": "0 4px 8px rgba(0, 0, 0, 0.1)",
      
      
//       "boxSizing": "border-box",
//       "display": "flex",
//       "flexDirection": "0px",
//       "gap": "8px"
//     },
//     "default_fields": {},
//     "is_default_value": false,
//     "add_display_name": false
//   }
// ],
//     },
//   },
  {
    uiName: "Pizza menu2",
    artifact_id: "a1b2c3d4-e5f6-7890-1234-567890abcdef",
    title: "Pizza Menu",
    contentType: "application/json",
    data: {
      time: 1749903900000,
      blocks: [
  {
    "id": "block-margherita-title",
    "type": "header",
    "display_name": "Margherita Pizza",
    "data": {
      "elements": [
        {
          "field": "text",
          "value": "Margherita Pizza"
        },
        {
          "field": "display_name",
          "value": "name"
        }
      ]
    },
    "css": {
      "header": {
        "color": "#1a1a1a",
        "fontWeight": "700",
        "margin": "0",
        "fontFamily": "'Montserrat', sans-serif",
        "fontSize": "28px",
        "boxSizing": "border-box",
        "transition": "all 0.3s ease",
        "letterSpacing": "1px",
        "textTransform": "uppercase",
        "textAlign": "center"
      },
      "displayName": {
        "fontSize": "20px",
        "fontWeight": "600",
        "color": "#1a1a1a",
        "marginBottom": "0",
        "fontFamily": "'Montserrat', sans-serif",
        "transition": "all 0.3s ease"
      },
      "displayNameContainer": {
        "backgroundColor": "transparent",
        "marginBottom": "0",
        "transition": "all 0.3s ease",
        "textAlign": "center"
      }
    },
    "outerCss": {
      "backgroundColor": "#fafafa",
      "justifyContent": "center",
      "alignItems": "center",
      "padding": "0",
      "textAlign": "center",
      "boxShadow": "0 8px 16px rgba(0, 0, 0, 0.1)",
      "borderRadius": "10px",
      "boxSizing": "border-box",
      "display": "flex",
      "flexDirection": "row",
      "gap": "15px"
    },
    "default_fields": {},
    "is_default_value": false,
    "add_display_name": false
  },
  {
    "id": "block-margherita-description",
    "type": "paragraph",
    "display_name": "Description",
    "data": {
      "elements": [
        {
          "field": "text",
          "value": "Our classic Margherita pizza features hand-tossed sourdough crust, topped with premium San Marzano tomatoes, fresh mozzarella di bufala, aromatic basil, and a drizzle of cold-pressed extra virgin olive oil."
        },
        {
          "field": "display_name",
          "value": "Description"
        }
      ]
    },
    "css": {
      "paragraph": {
        "color": "#333333",
        "fontSize": "16px",
        "margin": "0",
        "fontFamily": "'Lora', serif",
        "boxSizing": "border-box",
        "transition": "all 0.3s ease",
        "textAlign": "center",
        "lineHeight": "1.8"
      },
      "displayName": {
        "fontSize": "16px",
        "fontWeight": "600",
        "color": "#1a1a1a",
        "marginBottom": "0",
        "fontFamily": "'Montserrat', sans-serif",
        "transition": "all 0.3s ease"
      },
      "displayNameContainer": {
        "backgroundColor": "transparent",
        "marginBottom": "0",
        "transition": "all 0.3s ease",
        "textAlign": "center"
      }
    },
    "outerCss": {
      "backgroundColor": "#fafafa",
      "justifyContent": "center",
      "alignItems": "center",
      "textAlign": "center",
      "padding": "0",
      "boxShadow": "0 8px 16px rgba(0, 0, 0, 0.1)",
      "borderRadius": "10px",
      "boxSizing": "border-box",
      "display": "flex",
      "flexDirection": "row",
      "gap": "15px"
    },
    "default_fields": {},
    "is_default_value": false,
    "add_display_name": false
  },
  {
    "id": "block-margherita-price-list",
    "type": "paragraph",
    "display_name": "Pricing",
    "data": {
      "elements": [
        {
          "field": "text",
          "value": "Select Your Size"
        },
        {
          "field": "display_name",
          "value": "Pricing"
        }
      ]
    },
    "css": {
      "paragraph": {
        "fontSize": "20px",
        "fontWeight": "700",
        "color": "#c62828",
        "margin": "0",
        "fontFamily": "'Montserrat', sans-serif",
        "boxSizing": "border-box",
        "textTransform": "uppercase",
        "transition": "all 0.3s ease",
        "textAlign": "center"
      },
      "displayName": {
        "fontSize": "20px",
        "fontWeight": "700",
        "color": "#c62828",
        "marginBottom": "0",
        "fontFamily": "'Montserrat', sans-serif",
        "transition": "all 0.3s ease"
      },
      "displayNameContainer": {
        "backgroundColor": "transparent",
        "marginBottom": "0",
        "transition": "all 0.3s ease",
        "textAlign": "center"
      }
    },
    "outerCss": {
      "backgroundColor": "#fafafa",
      "justifyContent": "center",
      "alignItems": "center",
      "textAlign": "center",
      "padding": "0",
      "boxShadow": "0 8px 16px rgba(0, 0, 0, 0.1)",
      "borderRadius": "10px",
      "boxSizing": "border-box",
      "display": "flex",
      "flexDirection": "row",
      "gap": "15px"
    },
    "default_fields": {},
    "is_default_value": false,
    "add_display_name": true
  },
  {
    "id": "block-margherita-price-small",
    "type": "paragraph",
    "display_name": "Base Price",
    "data": {
      "elements": [
        {
          "field": "text",
          "value": "$8.99"
        },
        {
          "field": "display_name",
          "value": "Small (10\")"
        }
      ]
    },
    "css": {
      "paragraph": {
        "fontSize": "18px",
        "fontWeight": "600",
        "color": "#c62828",
        "margin": "0",
        "fontFamily": "'Lora', serif",
        "boxSizing": "border-box",
        "transition": "all 0.3s ease",
        "textAlign": "center"
      },
      "displayName": {
        "fontSize": "18px",
        "fontWeight": "600",
        "color": "#c62828",
        "marginBottom": "0",
        "fontFamily": "'Lora', serif",
        "transition": "all 0.3s ease"
      },
      "displayNameContainer": {
        "backgroundColor": "transparent",
        "marginBottom": "0",
        "transition": "all 0.3s ease",
        "textAlign": "center"
      }
    },
    "outerCss": {
      "backgroundColor": "#fafafa",
      "justifyContent": "center",
      "alignItems": "center",
      "textAlign": "center",
      "padding": "0",
      "boxShadow": "0 8px 16px rgba(0, 0, 0, 0.1)",
      "borderRadius": "10px",
      "boxSizing": "border-box",
      "display": "flex",
      "flexDirection": "row",
      "gap": "20px"
    },
    "default_fields": {},
    "is_default_value": false,
    "add_display_name": true
  },
  {
    "id": "block-margherita-price-medium",
    "type": "paragraph",
    "display_name": "Base Price",
    "data": {
      "elements": [
        {
          "field": "text",
          "value": "$13.99"
        },
        {
          "field": "display_name",
          "value": "Medium (12\")"
        }
      ]
    },
    "css": {
      "paragraph": {
        "fontSize": "18px",
        "fontWeight": "600",
        "color": "#c62828",
        "margin": "0",
        "fontFamily": "'Lora', serif",
        "boxSizing": "border-box",
        "transition": "all 0.3s ease",
        "textAlign": "center"
      },
      "displayName": {
        "fontSize": "18px",
        "fontWeight": "600",
        "color": "#c62828",
        "marginBottom": "0",
        "fontFamily": "'Lora', serif",
        "transition": "all 0.3s ease"
      },
      "displayNameContainer": {
        "backgroundColor": "transparent",
        "marginBottom": "0",
        "transition": "all 0.3s ease",
        "textAlign": "center"
      }
    },
    "outerCss": {
      "backgroundColor": "#fafafa",
      "justifyContent": "center",
      "alignItems": "center",
      "textAlign": "center",
      "padding": "0",
      "boxShadow": "0 8px 16px rgba(0, 0, 0, 0.1)",
      "borderRadius": "10px",
      "boxSizing": "border-box",
      "display": "flex",
      "flexDirection": "row",
      "gap": "20px"
    },
    "default_fields": {},
    "is_default_value": false,
    "add_display_name": true
  },
  {
    "id": "block-margherita-price-large",
    "type": "paragraph",
    "display_name": "Base Price",
    "data": {
      "elements": [
        {
          "field": "text",
          "value": "$18.99"
        },
        {
          "field": "display_name",
          "value": "Large (14\")"
        }
      ]
    },
    "css": {
      "paragraph": {
        "fontSize": "18px",
        "fontWeight": "600",
        "color": "#c62828",
        "margin": "0",
        "fontFamily": "'Lora', serif",
        "boxSizing": "border-box",
        "transition": "all 0.3s ease",
        "textAlign": "center"
      },
      "displayName": {
        "fontSize": "18px",
        "fontWeight": "600",
        "color": "#c62828",
        "marginBottom": "0",
        "fontFamily": "'Lora', serif",
        "transition": "all 0.3s ease"
      },
      "displayNameContainer": {
        "backgroundColor": "transparent",
        "marginBottom": "0",
        "transition": "all 0.3s ease",
        "textAlign": "center"
      }
    },
    "outerCss": {
      "backgroundColor": "#fafafa",
      "justifyContent": "center",
      "alignItems": "center",
      "textAlign": "center",
      "padding": "0",
      "boxShadow": "0 8px 16px rgba(0, 0, 0, 0.1)",
      "borderRadius": "10px",
      "boxSizing": "border-box",
      "display": "flex",
      "flexDirection": "row",
      "gap": "20px"
    },
    "default_fields": {},
    "is_default_value": false,
    "add_display_name": true
  },
  {
    "id": "block-margherita-image",
    "type": "image",
    "display_name": "Pizza Image",
    "data": {
      "elements": [
        {
          "field": "files",
          "value": [
            {
              "url": "https://media.istockphoto.com/id/184946701/photo/pizza.jpg?s=612x612&w=0&k=20&c=97rc0VIi-s3mn4xe4xDy9S-XJ_Ohbn92XaEMaiID_eY="
            }
          ]
        },
        {
          "field": "display_name",
          "value": "Pizza Image"
        }
      ]
    },
    "css": {
      "image": {
        "width": "100%",
        "height": "250px",
        "objectFit": "cover",
        "borderRadius": "12px",
        "margin": "0",
        "boxSizing": "border-box",
        "alignSelf": "center",
        "boxShadow": "0 6px 12px rgba(0, 0, 0, 0.15)",
        "transition": "all 0.3s ease",
        "border": "3px solid #ffffff"
      },
      "displayName": {
        "fontSize": "18px",
        "fontWeight": "600",
        "color": "#1a1a1a",
        "marginBottom": "0",
        "fontFamily": "'Montserrat', sans-serif",
        "transition": "all 0.3s ease"
      },
      "displayNameContainer": {
        "backgroundColor": "transparent",
        "marginBottom": "0",
        "transition": "all 0.3s ease",
        "textAlign": "center"
      }
    },
    "outerCss": {
      "backgroundColor": "#fafafa",
      "justifyContent": "center",
      "alignItems": "center",
      "textAlign": "center",
      "padding": "0",
      "boxShadow": "0 8px 16px rgba(0, 0, 0, 0.1)",
      "borderRadius": "10px",
      "boxSizing": "border-box",
      "display": "flex",
      "flexDirection": "column",
      "gap": "15px"
    },
    "default_fields": {},
    "is_default_value": false,
    "add_display_name": false
  },
  {
    "id": "block-margherita-button",
    "type": "button",
    "display_name": "Order Now",
    "data": {
      "elements": [
        {
          "field": "text",
          "value": "Order Now"
        },
        {
          "field": "url",
          "value": "/order/margherita"
        },
        {
          "field": "display_name",
          "value": "Order Now"
        }
      ]
    },
    "css": {
      "button": {
        "backgroundColor": "#c62828",
        "color": "#ffffff",
        "padding": "14px 28px",
        "borderRadius": "12px",
        "fontSize": "18px",
        "fontFamily": "'Montserrat', sans-serif",
        "textTransform": "uppercase",
        "boxSizing": "border-box",
        "boxShadow": "0 6px 12px rgba(0, 0, 0, 0.15)",
        "transition": "all 0.3s ease",
        "cursor": "pointer",
        "width": "100%",
        "border": "none",
        "fontWeight": "700",
        "letterSpacing": "1.2px"
      },
      "buttonHover": {
        "backgroundColor": "#b71c1c",
        "transform": "scale(1.05)",
        "boxShadow": "0 8px 16px rgba(0, 0, 0, 0.2)"
      },
      "displayName": {
        "fontSize": "18px",
        "fontWeight": "600",
        "color": "#1a1a1a",
        "marginBottom": "0",
        "fontFamily": "'Montserrat', sans-serif",
        "transition": "all 0.3s ease"
      },
      "displayNameContainer": {
        "backgroundColor": "transparent",
        "marginBottom": "0",
        "transition": "all 0.3s ease",
        "textAlign": "center"
      }
    },
    "outerCss": {
      "backgroundColor": "#fafafa",
      "justifyContent": "center",
      "alignItems": "center",
      "textAlign": "center",
      "padding": "0",
      "boxShadow": "0 8px 16px rgba(0, 0, 0, 0.1)",
      "borderRadius": "10px",
      "boxSizing": "border-box",
      "display": "flex",
      "flexDirection": "column",
      "gap": "15px"
    },
    "default_fields": {},
    "is_default_value": false,
    "add_display_name": false
  }
],
    },
  },
  {
    uiName: "Corporate Catering Service",
    artifact_id: "a1b2c3d4-e5f6-7890-1234-567890abcdef",
    title: "Corporate Catering Service",
    contentType: "application/json",
    data: {
      time: 1749903900000,
      blocks: [
        {
          id: "block-1a2b3c4d-5e6f-7890-1234-567890abcdef",
          type: "header",
          display_name: "Catering Service Overview",
          data: {
            elements: [
              {
                field: "text",
                value: "Premium Corporate Catering Solutions",
              },
              {
                field: "display_name",
                value: "Catering Service Overview",
              },
            ],
          },
          css: {
            header: {
              fontSize: "24px",
              fontWeight: "700",
              margin: "16px 0",
              color: "#1a3c5e",
              fontFamily: "'Helvetica Neue', Arial, sans-serif",
              transition: "all 0.3s ease",
            },
            displayName: {
              fontSize: "18px",
              fontWeight: "600",
              color: "#1a3c5e",
              marginBottom: "8px",
              fontFamily: "'Helvetica Neue', Arial, sans-serif",
              transition: "all 0.3s ease",
            },
            displayNameContainer: {
              padding: "8px",
              backgroundColor: "#e8eef3",
              borderRadius: "4px",
              marginBottom: "8px",
              transition: "all 0.3s ease",
            },
          },
          outerCss: {
            backgroundColor: "#f8fafc",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          },
          default_fields: {},
          is_default_value: false,
          add_display_name: true,
        },
        {
          id: "block-2b3c4d5e-6f78-9012-3456-7890abcdef12",
          type: "image",
          display_name: "Catering Showcase",
          data: {
            elements: [
              {
                field: "files",
                value: [
                  {
                    url: "https://images.unsplash.com/photo-1515169067868-5387ec356754",
                  },
                ],
              },
              {
                field: "caption",
                value: "Gourmet Corporate Dining Experience",
              },
              {
                field: "display_name",
                value: "Catering Showcase",
              },
            ],
          },
          css: {
            image: {
              margin: "12px 0",
              borderRadius: "6px",
              //"maxWidth": "200px",
              width: "100%",
              height: "150px",
              objectFit: "cover",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              transition: "all 0.3s ease",
            },
            displayName: {
              fontSize: "16px",
              fontWeight: "600",
              color: "#1a3c5e",
              marginBottom: "8px",
              fontFamily: "'Helvetica Neue', Arial, sans-serif",
              transition: "all 0.3s ease",
            },
            displayNameContainer: {
              padding: "8px",
              backgroundColor: "#e8eef3",
              borderRadius: "4px",
              marginBottom: "8px",
              transition: "all 0.3s ease",
            },
          },
          outerCss: {
            backgroundColor: "#f8fafc",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          },
          default_fields: {},
          is_default_value: false,
          add_display_name: true,
        },
        {
          id: "block-3c4d5e6f-7890-1234-5678-90abcdef1234",
          type: "list",
          display_name: "Catering Menu Highlights",
          data: {
            elements: [
              {
                field: "items",
                value: [
                  "Executive Lunch Buffet",
                  "Customized Vegan Platter",
                  "Premium Dessert Selection",
                  "Beverage Packages",
                ],
              },
              {
                field: "display_name",
                value: "Catering Menu Highlights",
              },
            ],
          },
          css: {
            list: {
              fontSize: "16px",
              margin: "12px 0",
              paddingLeft: "20px",
              color: "#2d547b",
              fontFamily: "'Helvetica Neue', Arial, sans-serif",
              transition: "all 0.3s ease",
            },
            displayName: {
              fontSize: "16px",
              fontWeight: "600",
              color: "#1a3c5e",
              marginBottom: "8px",
              fontFamily: "'Helvetica Neue', Arial, sans-serif",
              transition: "all 0.3s ease",
            },
            displayNameContainer: {
              padding: "8px",
              backgroundColor: "#e8eef3",
              borderRadius: "4px",
              marginBottom: "8px",
              transition: "all 0.3s ease",
            },
          },
          outerCss: {
            backgroundColor: "#f8fafc",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "left",
          },
          default_fields: {},
          is_default_value: false,
          add_display_name: true,
        },
        {
          id: "block-new-pizza-details-1",
          type: "table",
          display_name: "Signature Pizza Offerings",
          data: {
            elements: [
              {
                field: "headers",
                value: [
                  "Pizza Type",
                  "Taste",
                  "Presentation",
                  "Ingredient Quality",
                  "Value",
                  "Total Score",
                ],
              },
              {
                field: "rows",
                value: [
                  ["Margherita Classico", "4.6", "4.2", "4.8", "4.3", "17.9"],
                  ["Pepperoni Supremo", "4.7", "4.4", "4.6", "4.2", "17.9"],
                  ["Vegan Artisanal", "4.5", "4.5", "4.7", "4.4", "18.1"],
                ],
              },
              {
                field: "display_name",
                value: "Signature Pizza Offerings",
              },
            ],
          },
          css: {
            table: {
              fontSize: "14px",
              margin: "12px 0",
              borderCollapse: "collapse",
              color: "#2d547b",
              fontFamily: "'Helvetica Neue', Arial, sans-serif",
              transition: "all 0.3s ease",
              //"maxWidth": "200px"
            },
            displayName: {
              fontSize: "16px",
              fontWeight: "600",
              color: "#1a3c5e",
              marginBottom: "8px",
              fontFamily: "'Helvetica Neue', Arial, sans-serif",
              transition: "all 0.3s ease",
            },
            displayNameContainer: {
              padding: "8px",
              backgroundColor: "#e8eef3",
              borderRadius: "4px",
              marginBottom: "8px",
              transition: "all 0.3s ease",
            },
          },
          outerCss: {
            backgroundColor: "#f8fafc",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "left",
          },
          default_fields: {},
          is_default_value: false,
          add_display_name: true,
        },
        {
          id: "block-4d5e6f78-9012-3456-7890-abcdef123456",
          type: "button",
          display_name: "Request a Quote",
          data: {
            elements: [
              {
                field: "text",
                value: "Request a Quote",
              },
              {
                field: "url",
                value: "#",
              },
              {
                field: "display_name",
                value: "Request a Quote",
              },
            ],
          },
          css: {
            button: {
              fontSize: "16px",
              padding: "8px 16px",
              backgroundColor: "#1a3c5e",
              color: "#fff",
              borderRadius: "4px",
              fontFamily: "'Helvetica Neue', Arial, sans-serif",
              textTransform: "uppercase",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
              transition: "all 0.3s ease",
              cursor: "pointer",
            },
            displayName: {
              fontSize: "16px",
              fontWeight: "600",
              color: "#1a3c5e",
              marginBottom: "8px",
              fontFamily: "'Helvetica Neue', Arial, sans-serif",
              transition: "all 0.3s ease",
            },
            displayNameContainer: {
              padding: "8px",
              backgroundColor: "#e8eef3",
              borderRadius: "4px",
              marginBottom: "8px",
              transition: "all 0.3s ease",
            },
          },
          outerCss: {
            backgroundColor: "#f8fafc",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          },
          default_fields: {},
          is_default_value: false,
          add_display_name: true,
        },
      ],
    },
  },
  {
    uiName: "Hotel Booking Overview",
    artifact_id: "b2c3d4e5-f6g7-8901-2345-678901bcdef1",
    title: "Hotel Booking Overview",
    contentType: "application/json",
    data: {
      time: 1749903900000,
      blocks: [
        {
          id: "block-5e6f7890-1234-5678-90ab-cdef12345678",
          type: "header",
          display_name: "Hotel Overview",
          data: {
            elements: [
              {
                field: "text",
                value: "Grand Ocean Hotel Reservations",
              },
              {
                field: "display_name",
                value: "Hotel Overview",
              },
            ],
          },
          css: {
            header: {
              fontSize: "24px",
              fontWeight: "700",
              margin: "16px 0",
              color: "#0d3b66",
              fontFamily: "'Roboto', Arial, sans-serif",
              transition: "all 0.3s ease",
            },
            displayName: {
              fontSize: "18px",
              fontWeight: "600",
              color: "#0d3b66",
              marginBottom: "8px",
              fontFamily: "'Roboto', Arial, sans-serif",
              transition: "all 0.3s ease",
            },
            displayNameContainer: {
              padding: "8px",
              backgroundColor: "#e6f0fa",
              borderRadius: "4px",
              marginBottom: "8px",
              transition: "all 0.3s ease",
            },
          },
          outerCss: {
            backgroundColor: "#f9fcff",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            textAlign: "left",
          },
          default_fields: {},
          is_default_value: false,
          add_display_name: true,
        },
        {
          id: "block-6f789012-3456-7890-abcd-ef1234567890",
          type: "map",
          display_name: "Hotel Location",
          data: {
            elements: [
              {
                field: "lat",
                value: "37.7749",
              },
              {
                field: "lng",
                value: "-122.4194",
              },
              {
                field: "display_name",
                value: "Hotel Location",
              },
            ],
          },
          css: {
            map: {
              margin: "12px 0",
              borderRadius: "6px",
              height: "200px",
              //"maxWidth": "200px",
              width: "100%",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              transition: "all 0.3s ease",
            },
            displayName: {
              fontSize: "16px",
              fontWeight: "600",
              color: "#0d3b66",
              marginBottom: "8px",
              fontFamily: "'Roboto', Arial, sans-serif",
              transition: "all 0.3s ease",
            },
            displayNameContainer: {
              padding: "8px",
              backgroundColor: "#e6f0fa",
              borderRadius: "4 znów px",
              marginBottom: "8px",
              transition: "all 0.3s ease",
            },
          },
          outerCss: {
            backgroundColor: "#f9fcff",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            textAlign: "left",
          },
          default_fields: {},
          is_default_value: false,
          add_display_name: true,
        },
        {
          id: "block-78901234-5678-90ab-cdef-1234567890ab",
          type: "paragraph",
          display_name: "Hotel Amenities",
          data: {
            elements: [
              {
                field: "text",
                value:
                  "Experience luxury at Grand Ocean Hotel, featuring 200 rooms, 3 restaurants, and a rooftop pool. Rated 4.5/5 by 1,234 guests.",
              },
              {
                field: "display_name",
                value: "Hotel Amenities",
              },
            ],
          },
          css: {
            paragraph: {
              fontSize: "16px",
              margin: "12px 0",
              color: "#2b4d77",
              lineHeight: "1.6",
              fontFamily: "'Roboto', Arial, sans-serif",
              transition: "all 0.3s ease",
            },
            displayName: {
              fontSize: "16px",
              fontWeight: "600",
              color: "#0d3b66",
              marginBottom: "8px",
              fontFamily: "'Roboto', Arial, sans-serif",
              transition: "all 0.3s ease",
            },
            displayNameContainer: {
              padding: "8px",
              backgroundColor: "#e6f0fa",
              borderRadius: "4px",
              marginBottom: "8px",
              transition: "all 0.3s ease",
            },
          },
          outerCss: {
            backgroundColor: "#f9fcff",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            textAlign: "left",
          },
          default_fields: {},
          is_default_value: false,
          add_display_name: true,
        },
        {
          id: "block-new-faq-1",
          type: "faq",
          display_name: "Booking FAQs",
          data: {
            elements: [
              {
                field: "items",
                value: [
                  {
                    question: "What is the check-in time?",
                    answer: "Check-in is available from 3:00 PM.",
                  },
                  {
                    question: "Are pets allowed?",
                    answer: "Pets are welcome with a $50 fee per stay.",
                  },
                  {
                    question: "Is parking available?",
                    answer: "Complimentary valet parking is provided.",
                  },
                ],
              },
              {
                field: "display_name",
                value: "Booking FAQs",
              },
            ],
          },
          css: {
            faq: {
              fontSize: "14px",
              margin: "12px 0",
              color: "#2b4d77",
              fontFamily: "'Roboto', Arial, sans-serif",
              transition: "all 0.3s ease",
              //"maxWidth": "200px"
            },
            displayName: {
              fontSize: "16px",
              fontWeight: "600",
              color: "#0d3b66",
              marginBottom: "8px",
              fontFamily: "'Roboto', Arial, sans-serif",
              transition: "all 0.3s ease",
            },
            displayNameContainer: {
              padding: "8px",
              backgroundColor: "#e6f0fa",
              borderRadius: "4px",
              marginBottom: "8px",
              transition: "all 0.3s ease",
            },
          },
          outerCss: {
            backgroundColor: "#f9fcff",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            textAlign: "left",
          },
          default_fields: {},
          is_default_value: false,
          add_display_name: true,
        },
        {
          id: "block-89012345-6789-0abc-def1-234567890abc",
          type: "button",
          display_name: "Reserve Now",
          data: {
            elements: [
              {
                field: "text",
                value: "Reserve Now",
              },
              {
                field: "url",
                value: "#",
              },
              {
                field: "display_name",
                value: "Reserve Now",
              },
            ],
          },
          css: {
            button: {
              fontSize: "16px",
              padding: "8px 16px",
              backgroundColor: "#0d3b66",
              color: "#fff",
              borderRadius: "4px",
              fontFamily: "'Roboto', Arial, sans-serif",
              textTransform: "uppercase",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
              transition: "all 0.3s ease",
              cursor: "pointer",
            },
            displayName: {
              fontSize: "16px",
              fontWeight: "600",
              color: "#0d3b66",
              marginBottom: "8px",
              fontFamily: "'Roboto', Arial, sans-serif",
              transition: "all 0.3s ease",
            },
            displayNameContainer: {
              padding: "8px",
              backgroundColor: "#e6f0fa",
              borderRadius: "4px",
              marginBottom: "8px",
              transition: "all 0.3s ease",
            },
          },
          outerCss: {
            backgroundColor: "#f9fcff",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            textAlign: "left",
          },
          default_fields: {},
          is_default_value: false,
          add_display_name: true,
        },
      ],
    },
  },
  {
    uiName: "Travel Itinerary",
    artifact_id: "c3d4e5f6-g7h8-9012-3456-789012bcdef2",
    title: "Travel Itinerary",
    contentType: "application/json",
    data: {
      time: 1749903900000,
      blocks: [
        {
          id: "block-90123456-7890-abcd-ef12-34567890abcd",
          type: "header",
          display_name: "Itinerary Overview",
          data: {
            elements: [
              {
                field: "text",
                value: "Curated Paris Travel Itinerary",
              },
              {
                field: "display_name",
                value: "Itinerary Overview",
              },
            ],
          },
          css: {
            header: {
              fontSize: "24px",
              fontWeight: "700",
              margin: "16px 0",
              color: "#1e3a5f",
              fontFamily: "'Open Sans', Arial, sans-serif",
              transition: "all 0.3s ease",
            },
            displayName: {
              fontSize: "18px",
              fontWeight: "600",
              color: "#1e3a5f",
              marginBottom: "8px",
              fontFamily: "'Open Sans', Arial, sans-serif",
              transition: "all 0.3s ease",
            },
            displayNameContainer: {
              padding: "8px",
              backgroundColor: "#ebedf0",
              borderRadius: "4px",
              marginBottom: "8px",
              transition: "all 0.3s ease",
            },
          },
          outerCss: {
            backgroundColor: "#f9f9fb",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          },
          default_fields: {},
          is_default_value: false,
          add_display_name: true,
        },
        {
          id: "block-01234567-89ab-cdef-1234-567890123456",
          type: "image",
          display_name: "Destination Highlight",
          data: {
            elements: [
              {
                field: "files",
                value: [
                  {
                    url: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34",
                  },
                ],
              },
              {
                field: "caption",
                value: "Iconic Eiffel Tower, Paris",
              },
              {
                field: "display_name",
                value: "Destination Highlight",
              },
            ],
          },
          css: {
            image: {
              margin: "12px 0",
              borderRadius: "6px",
              //"maxWidth": "200px",
              width: "100%",
              height: "150px",
              objectFit: "cover",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              transition: "all 0.3s ease",
            },
            displayName: {
              fontSize: "16px",
              fontWeight: "600",
              color: "#1e3a5f",
              marginBottom: "8px",
              fontFamily: "'Open Sans', Arial, sans-serif",
              transition: "all 0.3s ease",
            },
            displayNameContainer: {
              padding: "8px",
              backgroundColor: "#ebedf0",
              borderRadius: "4px",
              marginBottom: "8px",
              transition: "all 0.3s ease",
            },
          },
          outerCss: {
            backgroundColor: "#f9f9fb",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          },
          default_fields: {},
          is_default_value: false,
          add_display_name: true,
        },
        {
          id: "block-12345678-9abc-def1-2345-678901234567",
          type: "table",
          display_name: "Itinerary Schedule",
          data: {
            elements: [
              {
                field: "headers",
                value: ["Day", "Activity", "Time"],
              },
              {
                field: "rows",
                value: [
                  ["Day 1", "Eiffel Tower Tour", "10:00 AM"],
                  ["Day 1", "Seine River Cruise", "3:00 PM"],
                  ["Day 2", "Louvre Museum", "9:00 AM"],
                  ["Day 2", "Montmartre Walk", "2:00 PM"],
                ],
              },
              {
                field: "display_name",
                value: "Itinerary Schedule",
              },
            ],
          },
          css: {
            table: {
              fontSize: "14px",
              margin: "12px 0",
              borderCollapse: "collapse",
              color: "#2e4b7a",
              fontFamily: "'Open Sans', Arial, sans-serif",
              transition: "all 0.3s ease",
              //"maxWidth": "200px"
            },
            displayName: {
              fontSize: "16px",
              fontWeight: "600",
              color: "#1e3a5f",
              marginBottom: "8px",
              fontFamily: "'Open Sans', Arial, sans-serif",
              transition: "all 0.3s ease",
            },
            displayNameContainer: {
              padding: "8px",
              backgroundColor: "#ebedf0",
              borderRadius: "4px",
              marginBottom: "8px",
              transition: "all 0.3s ease",
            },
          },
          outerCss: {
            backgroundColor: "#f9f9fb",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "left",
          },
          default_fields: {},
          is_default_value: false,
          add_display_name: true,
        },
        {
          id: "block-new-faq-2",
          type: "faq",
          display_name: "Travel FAQs",
          data: {
            elements: [
              {
                field: "items",
                value: [
                  {
                    question: "What is included in the itinerary?",
                    answer:
                      "All activities, guided tours, and entry fees are included.",
                  },
                  {
                    question: "Can I customize my itinerary?",
                    answer: "Yes, customization is available upon request.",
                  },
                  {
                    question: "What is the cancellation policy?",
                    answer:
                      "Cancellations up to 7 days prior receive a full refund.",
                  },
                ],
              },
              {
                field: "display_name",
                value: "Travel FAQs",
              },
            ],
          },
          css: {
            faq: {
              fontSize: "14px",
              margin: "12px 0",
              color: "#2e4b7a",
              fontFamily: "'Open Sans', Arial, sans-serif",
              transition: "all 0.3s ease",
              //"maxWidth": "200px"
            },
            displayName: {
              fontSize: "16px",
              fontWeight: "600",
              color: "#1e3a5f",
              marginBottom: "8px",
              fontFamily: "'Open Sans', Arial, sans-serif",
              transition: "all 0.3s ease",
            },
            displayNameContainer: {
              padding: "8px",
              backgroundColor: "#ebedf0",
              borderRadius: "4px",
              marginBottom: "8px",
              transition: "all 0.3s ease",
            },
          },
          outerCss: {
            backgroundColor: "#f9f9fb",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "left",
          },
          default_fields: {},
          is_default_value: false,
          add_display_name: true,
        },
        {
          id: "block-23456789-abcd-ef12-3456-789012345678",
          type: "button",
          display_name: "View Complete Itinerary",
          data: {
            elements: [
              {
                field: "text",
                value: "View Complete Itinerary",
              },
              {
                field: "url",
                value: "#",
              },
              {
                field: "display_name",
                value: "View Complete Itinerary",
              },
            ],
          },
          css: {
            button: {
              fontSize: "16px",
              padding: "8px 16px",
              backgroundColor: "#1e3a5f",
              color: "#fff",
              borderRadius: "4px",
              fontFamily: "'Open Sans', Arial, sans-serif",
              textTransform: "uppercase",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
              transition: "all 0.3s ease",
              cursor: "pointer",
            },
            displayName: {
              fontSize: "16px",
              fontWeight: "600",
              color: "#1e3a5f",
              marginBottom: "8px",
              fontFamily: "'Open Sans', Arial, sans-serif",
              transition: "all 0.3s ease",
            },
            displayNameContainer: {
              padding: "8px",
              backgroundColor: "#ebedf0",
              borderRadius: "4px",
              marginBottom: "8px",
              transition: "all 0.3s ease",
            },
          },
          outerCss: {
            backgroundColor: "#f9f9fb",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          },
          default_fields: {},
          is_default_value: false,
          add_display_name: true,
        },
      ],
    },
  },
  {
    uiName: "Restaurant Reservation",
    artifact_id: "d4e5f6g7-h8i9-0123-4567-890123cdef34",
    title: "Restaurant Reservation",
    contentType: "application/json",
    data: {
      time: 1749903900000,
      blocks: [
        {
          id: "block-34567890-abcd-ef12-3456-789012345679",
          type: "header",
          display_name: "Dining Reservations",
          data: {
            elements: [
              {
                field: "text",
                value: "Fine Dining at La Belle Époque",
              },
              {
                field: "display_name",
                value: "Dining Reservations",
              },
            ],
          },
          css: {
            header: {
              fontSize: "24px",
              fontWeight: "700",
              margin: "16px 0",
              color: "#2e2e2e",
              fontFamily: "'Georgia', serif",
              transition: "all 0.3s ease",
            },
            displayName: {
              fontSize: "18px",
              fontWeight: "600",
              color: "#2e2e2e",
              marginBottom: "8px",
              fontFamily: "'Georgia', serif",
              transition: "all 0.3s ease",
            },
            displayNameContainer: {
              padding: "8px",
              backgroundColor: "#f5f5f5",
              borderRadius: "4px",
              marginBottom: "8px",
              transition: "all 0.3s ease",
            },
          },
          outerCss: {
            backgroundColor: "#fafafa",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          },
          default_fields: {},
          is_default_value: false,
          add_display_name: true,
        },
        {
          id: "block-45678901-2345-6789-0123-456789012345",
          type: "paragraph",
          display_name: "Restaurant Overview",
          data: {
            elements: [
              {
                field: "text",
                value:
                  "Indulge in an exquisite dining experience at La Belle Époque, where seasonal menus are crafted by award-winning chefs.",
              },
              {
                field: "display_name",
                value: "Restaurant Overview",
              },
            ],
          },
          css: {
            paragraph: {
              fontSize: "16px",
              margin: "12px 0",
              color: "#4a4a4a",
              lineHeight: "1.6",
              fontFamily: "'Georgia', serif",
              transition: "all 0.3s ease",
            },
            displayName: {
              fontSize: "16px",
              fontWeight: "600",
              color: "#2e2e2e",
              marginBottom: "8px",
              fontFamily: "'Georgia', serif",
              transition: "all 0.3s ease",
            },
            displayNameContainer: {
              padding: "8px",
              backgroundColor: "#f5f5f5",
              borderRadius: "4px",
              marginBottom: "8px",
              transition: "all 0.3s ease",
            },
          },
          outerCss: {
            backgroundColor: "#fafafa",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "left",
          },
          default_fields: {},
          is_default_value: false,
          add_display_name: true,
        },
        {
          id: "block-56789012-3456-7890-1234-567890123456",
          type: "faq",
          display_name: "Reservation FAQs",
          data: {
            elements: [
              {
                field: "items",
                value: [
                  {
                    question: "What is the dress code?",
                    answer: "Smart casual attire is recommended.",
                  },
                  {
                    question: "Can I modify my reservation?",
                    answer:
                      "Yes, modifications can be made up to 24 hours in advance.",
                  },
                  {
                    question: "Is there a cancellation fee?",
                    answer: "Cancellations within 12 hours incur a $20 fee.",
                  },
                ],
              },
              {
                field: "display_name",
                value: "Reservation FAQs",
              },
            ],
          },
          css: {
            faq: {
              fontSize: "14px",
              margin: "12px 0",
              color: "#4a4a4a",
              fontFamily: "'Georgia', serif",
              transition: "all 0.3s ease",
              //"maxWidth": "200px"
            },
            displayName: {
              fontSize: "16px",
              fontWeight: "600",
              color: "#2e2e2e",
              marginBottom: "8px",
              fontFamily: "'Georgia', serif",
              transition: "all 0.3s ease",
            },
            displayNameContainer: {
              padding: "8px",
              backgroundColor: "#f5f5f5",
              borderRadius: "4px",
              marginBottom: "8px",
              transition: "all 0.3s ease",
            },
          },
          outerCss: {
            backgroundColor: "#fafafa",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "left",
          },
          default_fields: {},
          is_default_value: false,
          add_display_name: true,
        },
        {
          id: "block-new-pizza-details-2",
          type: "table",
          display_name: "Gourmet Pizza Menu",
          data: {
            elements: [
              {
                field: "headers",
                value: [
                  "Pizza Type",
                  "Taste",
                  "Presentation",
                  "Ingredient Quality",
                  "Value",
                  "Total Score",
                ],
              },
              {
                field: "rows",
                value: [
                  [
                    "Truffle & Caviar Delight",
                    "4.9",
                    "4.8",
                    "5.0",
                    "4.2",
                    "18.9",
                  ],
                  ["Gold Leaf Margherita", "4.8", "4.9", "4.9", "4.3", "18.9"],
                  ["Wild Mushroom Medley", "4.7", "4.6", "4.8", "4.4", "18.5"],
                ],
              },
              {
                field: "display_name",
                value: "Gourmet Pizza Menu",
              },
            ],
          },
          css: {
            table: {
              fontSize: "14px",
              margin: "12px 0",
              borderCollapse: "collapse",
              color: "#4a4a4a",
              fontFamily: "'Georgia', serif",
              transition: "all 0.3s ease",
              //"maxWidth": "200px"
            },
            displayName: {
              fontSize: "16px",
              fontWeight: "600",
              color: "#2e2e2e",
              marginBottom: "8px",
              fontFamily: "'Georgia', serif",
              transition: "all 0.3s ease",
            },
            displayNameContainer: {
              padding: "8px",
              backgroundColor: "#f5f5f5",
              borderRadius: "4px",
              marginBottom: "8px",
              transition: "all 0.3s ease",
            },
          },
          outerCss: {
            backgroundColor: "#fafafa",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "left",
          },
          default_fields: {},
          is_default_value: false,
          add_display_name: true,
        },
        {
          id: "block-67890123-4567-8901-2345-678901234567",
          type: "button",
          display_name: "Secure Table Reservation",
          data: {
            elements: [
              {
                field: "text",
                value: "Secure Table Reservation",
              },
              {
                field: "url",
                value: "#",
              },
              {
                field: "display_name",
                value: "Secure Table Reservation",
              },
            ],
          },
          css: {
            button: {
              fontSize: "16px",
              padding: "8px 16px",
              backgroundColor: "#2e2e2e",
              color: "#fff",
              borderRadius: "4px",
              fontFamily: "'Georgia', serif",
              textTransform: "uppercase",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
              transition: "all 0.3s ease",
              cursor: "pointer",
            },
            displayName: {
              fontSize: "16px",
              fontWeight: "600",
              color: "#2e2e2e",
              marginBottom: "8px",
              fontFamily: "'Georgia', serif",
              transition: "all 0.3s ease",
            },
            displayNameContainer: {
              padding: "8px",
              backgroundColor: "#f5f5f5",
              borderRadius: "4px",
              marginBottom: "8px",
              transition: "all 0.3s ease",
            },
          },
          outerCss: {
            backgroundColor: "#fafafa",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          },
          default_fields: {},
          is_default_value: false,
          add_display_name: true,
        },
      ],
    },
  },
  {
    uiName: "Event Registration",
    artifact_id: "e5f6g7h8-i9j0-1234-5678-901234def567",
    title: "Event Registration",
    contentType: "application/json",
    data: {
      time: 1749903900000,
      blocks: [
        {
          id: "block-78901234-5678-90ab-cdef-1234567890ab",
          type: "header",
          display_name: "Conference Details",
          data: {
            elements: [
              {
                field: "text",
                value: "Annual Business Conference 2025",
              },
              {
                field: "display_name",
                value: "Conference Details",
              },
            ],
          },
          css: {
            header: {
              fontSize: "24px",
              fontWeight: "700",
              margin: "16px 0",
              color: "#1a3c34",
              fontFamily: "'Verdana', Arial, sans-serif",
              transition: "all 0.3s ease",
            },
            displayName: {
              fontSize: "18px",
              fontWeight: "600",
              color: "#1a3c34",
              marginBottom: "8px",
              fontFamily: "'Verdana', Arial, sans-serif",
              transition: "all 0.3s ease",
            },
            displayNameContainer: {
              padding: "8px",
              backgroundColor: "#e6edeb",
              borderRadius: "4px",
              marginBottom: "8px",
              transition: "all 0.3s ease",
            },
          },
          outerCss: {
            backgroundColor: "#f7f9f8",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          },
          default_fields: {},
          is_default_value: false,
          add_display_name: true,
        },
        {
          id: "block-89012345-6789-0abc-def1-234567890abc",
          type: "quote",
          display_name: "Event Highlight",
          data: {
            elements: [
              {
                field: "text",
                value:
                  "Engage with industry leaders to shape the future of business innovation.",
              },
              {
                field: "display_name",
                value: "Event Highlight",
              },
            ],
          },
          css: {
            quote: {
              fontSize: "16px",
              fontStyle: "italic",
              margin: "12px 0",
              padding: "0 16px",
              borderLeft: "4px solid #3d7e74",
              color: "#2e5e56",
              fontFamily: "'Verdana', Arial, sans-serif",
              transition: "all 0.3s ease",
            },
            displayName: {
              fontSize: "16px",
              fontWeight: "600",
              color: "#1a3c34",
              marginBottom: "8px",
              fontFamily: "'Verdana', Arial, sans-serif",
              transition: "all 0.3s ease",
            },
            displayNameContainer: {
              padding: "8px",
              backgroundColor: "#e6edeb",
              borderRadius: "4px",
              marginBottom: "8px",
              transition: "all 0.3s ease",
            },
          },
          outerCss: {
            backgroundColor: "#f7f9f8",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "left",
          },
          default_fields: {},
          is_default_value: false,
          add_display_name: true,
        },
        {
          id: "block-90123456-7890-abcd-ef12-34567890abcd",
          type: "list",
          display_name: "Key Conference Sessions",
          data: {
            elements: [
              {
                field: "items",
                value: [
                  "Keynote: Future of AI",
                  "Panel: Sustainable Business Practices",
                  "Workshop: Leadership Strategies",
                  "Networking Dinner",
                ],
              },
              {
                field: "display_name",
                value: "Key Conference Sessions",
              },
            ],
          },
          css: {
            list: {
              fontSize: "16px",
              margin: "12px 0",
              paddingLeft: "20px",
              color: "#2e5e56",
              fontFamily: "'Verdana', Arial, sans-serif",
              transition: "all 0.3s ease",
            },
            displayName: {
              fontSize: "16px",
              fontWeight: "600",
              color: "#1a3c34",
              marginBottom: "8px",
              fontFamily: "'Verdana', Arial, sans-serif",
              transition: "all 0.3s ease",
            },
            displayNameContainer: {
              padding: "8px",
              backgroundColor: "#e6edeb",
              borderRadius: "4px",

              marginBottom: "8px",
              transition: "all 0.3s ease",
            },
          },
          outerCss: {
            backgroundColor: "#f7f9f8",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "left",
          },
          default_fields: {},
          is_default_value: false,
          add_display_name: true,
        },
        {
          id: "block-new-pizza-details-3",
          type: "table",
          display_name: "Conference Catering Menu",
          data: {
            elements: [
              {
                field: "headers",
                value: [
                  "Pizza Type",
                  "Taste",
                  "Presentation",
                  "Ingredient Quality",
                  "Value",
                  "Total Score",
                ],
              },
              {
                field: "rows",
                value: [
                  ["Buffalo Mozzarella", "4.8", "4.6", "4.9", "4.3", "18.6"],
                  ["Smoked Salmon", "4.9", "4.7", "4.8", "4.2", "18.6"],
                  ["Pesto & Pine Nut", "4.7", "4.5", "4.8", "4.4", "18.4"],
                ],
              },
              {
                field: "display_name",
                value: "Conference Catering Menu",
              },
            ],
          },
          css: {
            table: {
              fontSize: "14px",
              margin: "12px 0",
              borderCollapse: "collapse",
              color: "#2e5e56",
              fontFamily: "'Verdana', Arial, sans-serif",
              transition: "all 0.3s ease",
              //"maxWidth": "200px"
            },
            displayName: {
              fontSize: "16px",
              fontWeight: "600",
              color: "#1a3c34",
              marginBottom: "8px",
              fontFamily: "'Verdana', Arial, sans-serif",
              transition: "all 0.3s ease",
            },
            displayNameContainer: {
              padding: "8px",
              backgroundColor: "#e6edeb",
              borderRadius: "4px",
              marginBottom: "8px",
              transition: "all 0.3s ease",
            },
          },
          outerCss: {
            backgroundColor: "#f7f9f8",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "left",
          },
          default_fields: {},
          is_default_value: false,
          add_display_name: true,
        },
        {
          id: "block-new-faq-3",
          type: "faq",
          display_name: "Event FAQs",
          data: {
            elements: [
              {
                field: "items",
                value: [
                  {
                    question: "What is included in the registration?",
                    answer:
                      "Access to all sessions, meals, and networking events.",
                  },
                  {
                    question: "Is there a group discount?",
                    answer: "Yes, groups of 5 or more receive a 10% discount.",
                  },
                  {
                    question: "Can I cancel my registration?",
                    answer:
                      "Cancellations before April 1, 2025, receive a full refund.",
                  },
                ],
              },
              {
                field: "display_name",
                value: "Event FAQs",
              },
            ],
          },
          css: {
            faq: {
              fontSize: "14px",
              margin: "12px 0",
              color: "#2e5e56",
              fontFamily: "'Verdana', Arial, sans-serif",
              transition: "all 0.3s ease",
              //"maxWidth": "200px"
            },
            displayName: {
              fontSize: "16px",
              fontWeight: "600",
              color: "#1a3c34",
              marginBottom: "8px",
              fontFamily: "'Verdana', Arial, sans-serif",
              transition: "all 0.3s ease",
            },
            displayNameContainer: {
              padding: "8px",
              backgroundColor: "#e6edeb",
              borderRadius: "4px",
              marginBottom: "8px",
              transition: "all 0.3s ease",
            },
          },
          outerCss: {
            backgroundColor: "#f7f9f8",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "left",
          },
          default_fields: {},
          is_default_value: false,
          add_display_name: true,
        },
        {
          id: "block-01234567-89ab-cdef-1234-567890123456",
          type: "button",
          display_name: "Register for Conference",
          data: {
            elements: [
              {
                field: "text",
                value: "Register for Conference",
              },
              {
                field: "url",
                value: "#",
              },
              {
                field: "display_name",
                value: "Register for Conference",
              },
            ],
          },
          css: {
            button: {
              fontSize: "16px",
              padding: "8px 16px",
              backgroundColor: "#1a3c34",
              color: "#fff",
              borderRadius: "4px",
              fontFamily: "'Verdana', Arial, sans-serif",
              textTransform: "uppercase",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
              transition: "all 0.3s ease",
              cursor: "pointer",
            },
            displayName: {
              fontSize: "16px",
              fontWeight: "600",
              color: "#1a3c34",
              marginBottom: "8px",
              fontFamily: "'Verdana', Arial, sans-serif",
              transition: "all 0.3s ease",
            },
            displayNameContainer: {
              padding: "8px",
              backgroundColor: "#e6edeb",
              borderRadius: "4px",
              marginBottom: "8px",
              transition: "all 0.3s ease",
            },
          },
          outerCss: {
            backgroundColor: "#f7f9f8",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          },
          default_fields: {},
          is_default_value: false,
          add_display_name: true,
        },
      ],
    },
  },
];